<template>
    <div id="product">
        <!-- 标题 -->
        <div class="breadcrumb c-pointer f-l" @click="tolist" >
            <span class="c-pointer m-r-12"><span v-show="!editProShow">产品列表</span><img v-if="cssType" :src="back" v-show="editProShow"></span><span v-show="editProShow">{{nowProObj.name}}</span>
        </div>
        <!-- 列表 -->
        <div class="list-box" v-show="listShow">
            <div class="bg">
                <div class="list-top clearfix">
                    <el-button type="primary" class="add-btn" @click="showAdd" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook">新建产品</el-button>
                    <div class="f-r">
                        <div class="search-btn">
                            <el-button type="primary" class="add-btn" @click="search">搜索</el-button>
                        </div>
                        <div class="search">
                            <el-input
                                placeholder="请输入产品名称或key"
                                v-model="searchVal" class="search-input" @keyup.enter.native="search">
                                <i slot="suffix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                    </div>
                    <div class="f-r category-box" v-if="cascaderShow">
                        <span>产品筛选：</span>
                        <el-cascader :options="selectCategoryData"  :key='cascaderKey' :props="optionProps" class="cascader f-r" v-model="categoryId">
                            <template slot-scope="{ node, data }">
                                <span>{{ data.name}}</span>
                              </template>
                        </el-cascader> <!--:show-all-levels="false"-->
                    </div>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title">
                        <li >产品名称</li>
                        <li class="w-90">key</li>
                        <li >产品类别</li>
                        <li class="w-90">节点类型</li>
                        <li class="w-90 t-right">引用计数</li>
                        <li class="w-18">备注</li>
                        <li class="w-90">操作</li>
                    </ul>
                    <div class="scroll" style="overflow: auto !important;">
                        <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
                            <li :title="item.name">{{item.name}}</li>
                            <li class="w-90">{{item.code}}</li>
                            <li :title="item.categoryName">{{getCategory(item.categoryId)}}{{item.categoryName}}</li>
                            <li class="w-90">{{item.nodeType==1?'网关设备':item.nodeType==2?'网关子设备':'直连设备'}}</li>
                            <li class="w-90 t-right">{{item.referenceCount}}</li>
                            <li class="w-18" :title="item.note">{{item.note}}</li>
                            <li class="operate w-90">
                                <span @click="operate(item,'editProShow',i)">{{$store.state.functionList.includes('productEdit')&&!$store.state.isLook?'编辑':'查看'}}</span>
                                <span :class="{'disabled':!$store.state.functionList.includes('productEdit')||$store.state.isLook||item.referenceCount!=0}" @click="operate(item,'delProShow',i)">删除</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="dataList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
        </div>
        <!-- 弹窗 -->
        <div class="popup">
            <!-- 删除产品 -->
            <div class="popup-delPro" v-show='delProShow'>
                <div class="popup-title">
                    删除产品<i class="el-icon-circle-close close" @click="close('delProShow')"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将删除该产品"{{nowObj.name}}"，是否继续
                </div>
                <p class="btn-box m-t-70"><el-button type="primary" :disabled="!$store.state.functionList.includes('productEdit')" @click='delPro'>确定</el-button><el-button @click="close('delProShow')">取消</el-button></p>
            </div>
            <!-- 新增产品 -->
            <div class="popup-addPro" v-show='addProShow'>
                <div class="popup-title">
                    新建产品<i class="el-icon-circle-close close" @click="close('addProShow')"></i>
                </div>
                <div class="popup-lab p-r">
                    <el-form :model="ruleForm" :rules="rules" ref="addProForm" class="clearfix" :disabled="!$store.state.functionList.includes('productEdit')">
                        <el-form-item prop="name" label="产品名称：" autocomplete="off" >
                            <i><img :src="notes" title="产品名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                            <el-input class="cascader" v-model="ruleForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="产品图片：" autocomplete="off" class="img p-a">
                            <i><img :src="notes" title="仅支持小于2MB的JPG和PNG文件" class="notes"></i>
                            <span class="logo-box"><input type="file" ref="addfile" class="file" accept="image/*" id="addfile"><img :src="ruleForm.file" @click="clickFile('add')" ref='addImg' id="addFileImg"></span>
                            <p class="red logoTip" ref="addlogo">仅支持小于2MB的JPG和PNG文件</p>
                        </el-form-item>
                        <el-form-item label="key：" autocomplete="off" class="m-b-10">
                            <el-input class="cascader" v-model="ruleForm.code" maxlength="32" @input="ruleForm.code = ruleForm.code.replace(/^([0-9])/,'').replace(/[^\w]/g,'').replace(/^_/g,'')"></el-input>
                        </el-form-item>
                        <el-form-item prop="categoryId" label="产品类别：" autocomplete="off" >
                            <i><img :src="notes" title="" class="notes"></i>
                            <el-cascader :options="categoryData" :key='cascaderKey' :props="optionProps" @change="setCategoryName" v-model="ruleForm.categoryId" class="cascader"></el-cascader>
                        </el-form-item>
                        <el-form-item prop="nodeType" label="产品类型：" autocomplete="off" class="m-b-0">
                            <el-radio-group v-model="ruleForm.nodeType" class="nodeType">
                                <el-radio :label=1>网关设备</el-radio>
                                <el-radio :label=2>网关子设备</el-radio>
                                <el-radio :label=3>直连设备</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="产品模板：" autocomplete="off" >
                            <i><img :src="notes" title="以现有产品作为模板自动添加功能和报警" class="notes"></i>
                            <el-cascader :options="productData" :key='cascaderKey' :props="optionProps" v-model="ruleForm.cloneId" class="cascader"></el-cascader>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                            <el-input
                                type="textarea"
                                class="remarks"
                                v-model="ruleForm.note"
                                maxlength="256"
                                show-word-limit
                                id="addRemarks"
                                placeholder="请输入内容">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <p class="btn-box"><el-button type="primary" @click="addPro('addProForm')">确定</el-button> <el-button @click="close('addProShow')">取消</el-button></p>
            </div>
            <!-- 编辑产品 -->
            <div class="popup-addPro" v-show='setProShow'>
                <div class="popup-title">
                    {{$store.state.functionList.includes('productEdit')&&!$store.state.isLook?'编辑':'查看'}}产品<i class="el-icon-circle-close close" @click="close('setProShow')"></i>
                </div>
                <div class="popup-lab p-r">
                    <el-form :model="ruleForm" :rules="rules" ref="editProForm" class="clearfix" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook">
                        <el-form-item prop="name" label="产品名称：" autocomplete="off">
                            <i><img :src="notes" title="产品名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                            <el-input class="cascader" v-model="ruleForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="产品图片：" autocomplete="off" class="img p-a">
                            <i><img :src="notes" title="仅支持小于2MB的JPG和PNG文件" class="notes"></i>
                            <span class="logo-box"><input type="file" ref="editfile" class="file" accept="image/*" id="editfile"><img :src="`${$store.state.imgUrl+ruleForm.image}`" @click="clickFile('edit')" ref='editImg' id="editFileImg"></span>
                            <p class="red logoTip" ref="editlogo">仅支持小于2MB的JPG和PNG文件</p>
                        </el-form-item>
                        <el-form-item label="key：" autocomplete="off" class="m-b-10">
                            <el-input class="cascader" v-model="ruleForm.code" maxlength="32" disabled></el-input>
                        </el-form-item>
                        <el-form-item prop="categoryId" label="产品类别：" autocomplete="off" >
                            <i><img :src="notes" title="" class="notes"></i>
                            <el-cascader disabled :options="categoryData" :key='cascaderKey' :props="optionProps" @change="setCategoryName"  v-model="ruleForm.categoryId" class="cascader"></el-cascader>
                        </el-form-item>
                        <el-form-item prop="nodeType" label="产品类型：" autocomplete="off" class="m-b-0">
                            <el-radio-group v-model="ruleForm.nodeType" class="nodeType" disabled>
                                <el-radio :label=1>网关设备</el-radio>
                                <el-radio :label=2>网关子设备</el-radio>
                                <el-radio :label=3>直连设备</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="产品模板：" autocomplete="off" >
                            <i><img :src="notes" title="以现有产品作为模板自动添加功能和报警" class="notes"></i>
                            <el-cascader disabled :options="productData" :key='cascaderKey' :props="optionProps" v-model="ruleForm.cloneId" class="cascader"></el-cascader>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                            <el-input
                                type="textarea"
                                class="remarks"
                                v-model="ruleForm.note"
                                maxlength="256"
                                show-word-limit
                                id="addRemarks2"
                                placeholder="请输入内容">
                            </el-input>
                        </el-form-item>
                        <p class="btn-box"><el-button type="primary" @click="editPro('editProForm')">确定</el-button> <el-button @click="close('setProShow')">取消</el-button></p>
                    </el-form>
                </div>

            </div>
            <!-- 删除产品功能 -->
            <div class="popup-delPro" v-show='delProFuncShow'>
                <div class="popup-title">
                    删除产品功能<i class="el-icon-circle-close close" @click="close('delProFuncShow')"></i>
                </div>
                <div class="popup-lab t-left">
                    是否确定将删除该功能
                </div>
                <p class="btn-box m-t-70"><el-button type="primary" :disabled="!$store.state.functionList.includes('productEdit')" @click='delProFunc'>确定</el-button><el-button @click="close('delProFuncShow')">取消</el-button></p>
            </div>
            <!-- 删除报警规则 -->
            <div class="popup-delPro" v-show='delProWarnShow'>
                <div class="popup-title">
                    删除报警规则<i class="el-icon-circle-close close" @click="close('delProWarnShow')"></i>
                </div>
                <div class="popup-lab t-left">
                    是否确定将删除该报警规则
                </div>
                <p class="btn-box m-t-70"><el-button type="primary" :disabled="!$store.state.functionList.includes('productEdit')" @click='delProWarn'>确定</el-button><el-button @click="close('delProWarnShow')">取消</el-button></p>
            </div>
            <!-- 验证码授权 -->
            <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;margin-left: -216px">
                <div class="popup-title">
                    获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
                </div>
                <div class="popup-lab">
                    手机号：
                    <el-input disabled v-model="phone">{{phone}}</el-input>
                </div>
                <div class="popup-lab clearfix">
                    <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                    <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                        <el-form-item prop="verifyCode">
                            <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="code-box">
                        <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                        <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                    </div>
                </div>
                <div class="popup-lab">
                    <p class="btn-box" style="margin-top: 46px;">
                        <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                        <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
                    </p>
                </div>
            </div>

        </div>
        <div class="editPro-box" v-show="editProShow">
            <div class="bg" style="height: 98%;">
                <div class="edit-top clearfix">
                    <p>key: {{nowProObj.code}} <span class="copy" @click="copy('copyTxt')">复制</span></p>
                    <p class="m-r-48">产品密钥: {{nowProObj.secret}} <span class="copy" @click="copy('copysecret')">复制</span></p>
                    <p>引用计数: {{nowProObj.referenceCount}}</p>
                    <textarea class="copy-obj" ref="copyTxt">{{nowProObj.code}}</textarea>
                    <textarea class="copy-obj" ref="copysecret">{{nowProObj.secret}}</textarea>
                </div>
                <div class="edit-btn-box">
                    <div :class="{'active':active==0}" @click="setActive(0)"><span class="border-0">产品信息</span></div>
                    <div :class="{'active':active==1}" @click="setActive(1)"><span>定义功能</span></div>
                    <div :class="{'active':active==2}" @click="setActive(2)"><span>产品报警</span></div>
                </div>
                <div class="pro-details" v-show="active==0">
                    <p class="details-p">基本信息<span @click="setPro">{{$store.state.functionList.includes('productEdit')?'编辑':'查看'}}</span></p>
                    <div class="details clearfix">
                        <span class="lab-title border-b">产品名称</span>
                        <span class="w-385 border-b">{{nowProObj.name}}</span>
                        <span class="lab-title border-b">节点类型</span>
                        <span class="w-409 border-b">{{nowProObj.nodeType==1?'网关设备':nowProObj.nodeType==2?'网关子设备':'直连设备'}}</span>
                        <span class="lab-title border-b">创建时间</span>
                        <span class="w-409 border-b">{{nowProObj.createdTime == null?'——':changeDate(nowProObj.createdTime)}}</span>
                        <span class="lab-title">产品类别</span>
                        <span class="w-385">{{getCategory(nowProObj.categoryId)}}{{nowProObj.categoryName}}</span>
                        <span class="lab-title">产品描述</span>
                        <span class="lab-note">{{nowProObj.note}}</span>
                    </div>
                    <!-- <p class="btn-box b-128"><el-button type="primary" @click="editPro" :disabled="!$store.state.functionList.includes('productEdit')">确定</el-button> <el-button @click="tolist">取消</el-button></p> -->
                </div>
                <div class="pro-function" v-show="active==1" style="height: 80%;">
                    <div class="clearfix">
                      <el-button type="primary" class="add-btn" @click="addFunction" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook">新建功能</el-button>
                      <el-button type="primary" class="add-btn" @click="importFunction" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook">导入</el-button>
                      <a class="add-btn download-btn" :href="'/api/v1/ProductFeature/export?productId='+nowProObj.id" v-if="$store.state.functionList.includes('productEdit')&&!$store.state.isLook">导出</a>
                      <el-button type="primary" class="add-btn" v-else :disabled="true">导出</el-button>
                      <el-button v-if="cssType==1" type="primary" class="px-btn f-r" @click="paixu(proFunction.properties)" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook" icon="el-icon-s-operation"></el-button>
                      <div class="f-r">
                          <div class="search-btn">
                              <el-button type="primary" class="add-btn" @click="searchAttr">搜索</el-button>
                          </div>
                          <div class="search w-250">
                              <el-input
                                  placeholder="请输入功能名称或标识符"
                                  v-model="searchAttrVal" class="search-input " @keyup.enter.native="searchAttr">
                                  <i slot="suffix" class="el-input__icon el-icon-search"></i>
                              </el-input>
                          </div>
                      </div>
                    </div>

                    <div class="clearfix" style="height: 98%;">
                        <ul class="list-title" style="position: relative; top: 17px; width: 100%; margin: 0;">
                            <li>功能名称</li>
                            <li class="w-18">标识符</li>
                            <li>数据类型</li>
                            <li class="w-26">数据定义</li>
                            <li class="w-90">读写类型</li>
                            <li class="w-90">操作</li>
                        </ul>
                        <div class="scroll w-100">
                            <ul class="list-details" v-for="(item,i) in proFunction.properties" :key="i" v-show="showCodeArr.includes(item.identifier)" >
                                <li :title="item.name">{{item.name}}</li>
                                <li class="w-18">{{item.identifier}}</li>
                                <li>{{item.dataType.type}}
                                    <span v-if="item.dataType.type=='int'">(整数型)</span>
                                    <span v-if="item.dataType.type=='bool'">(布尔型)</span>
                                    <span v-if="item.dataType.type=='enum'">(枚举型)</span>
                                    <span v-if="item.dataType.type=='float'">(单精度浮点型)</span>
                                    <span v-if="item.dataType.type=='double'">(双精度浮点型)</span>
                                    <span v-if="item.dataType.type=='text'">(字符串)</span>
                                    <span v-if="item.dataType.type=='date'">(时间)</span>
                                </li>
                                <li class="w-26">
                                    <span v-if="item.dataType.type == 'bool'||item.dataType.type == 'enum'" :title="replaceSpecs(item.dataType.specs)">{{replaceSpecs(item.dataType.specs)}}</span>
                                    <span v-if="item.dataType.type == 'text'" :title="'数据长度:'+item.dataType.specs.length">数据长度: {{item.dataType.specs.length}}</span>
                                    <span v-if="item.dataType.type == 'float'||item.dataType.type=='double'||item.dataType.type=='int'" :title="'取值范围:'+item.dataType.specs.min+' ~ '+item.dataType.specs.max">取值范围: {{item.dataType.specs.min}} ~ {{item.dataType.specs.max}}</span>
                                    <span v-if="item.dataType.type == 'date'">——</span>
                                </li>
                                <li class="w-90">{{item.accessMode=="rw"?"读写":"只读"}}</li>
                                <li class="operate w-90">
                                    <span @click="editFunc(item,i)">{{$store.state.functionList.includes('productEdit')&&!$store.state.isLook?'编辑':'查看'}}</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('productEdit')||$store.state.isLook}" @click="operate(item,'delProFuncShow',i)">删除</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="pro-function" v-show="active==2" style="height: 80%;">
                    <div class="clearfix">
                      <el-button type="primary" class="add-btn" @click="addAlarm" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook">新建报警规则</el-button>
                      <el-button type="primary" class="add-btn" @click="importRule" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook">导入</el-button>
                      <a class="add-btn download-btn" :href="'/api/v1/ProductAlarmRule/export?productId='+nowProObj.id" v-if="$store.state.functionList.includes('productEdit')&&!$store.state.isLook">导出</a>
                      <el-button type="primary" class="add-btn" v-else :disabled="true">导出</el-button>
                    </div>
                    <div class="clearfix" style="height: 98%;">
                        <ul class="list-title" style="position: relative; top: 17px; width: 100%; margin: 0;">
                            <li>报警名称</li>
                            <li class="w-18">报警类型</li>
                            <li>报警级别</li>
                            <li class="w-18">备注</li>
                            <li class="w-90">操作</li>
                        </ul>
                        <div class="scroll w-100">
                            <ul class="list-details" v-for="(item,i) in productAlarm" :key="i">
                                <li :title="item.name">{{item.name}}</li>
                                <li class="w-18" :title="item.typeNameSet">{{item.typeNameSet}}</li>
                                <li>{{item.level==1?"提示":item.level==2?"报警":"故障"}}</li>
                                <li class="w-18" :title="item.note">{{item.note}}</li>
                                <li class="operate w-90">
                                    <span @click="editAlarm(item,i)">{{$store.state.functionList.includes('productEdit')&&!$store.state.isLook?'编辑':'查看'}}</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('productEdit')||$store.state.isLook}" @click="operate(item,'delProWarnShow',i)">删除</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 功能弹窗 -->
            <div class="popup">
                <div class="popup-addFunc" v-show="addFuncShow">
                    <div class="popup-title">
                        新建功能<i class="el-icon-circle-close close" @click="close('addFuncShow')"></i>
                    </div>
                    <div class="poput-lab">
                        <el-form :model="ruleForm" :rules="rules" ref="addFunc" class="clearfix">
                            <el-form-item prop="funcName" label="功能名称：" autocomplete="off" >
                                <i><img :src="notes" title="须介于1~32个字符之间，支持中文、大小写字母、数字、短划线、下划线和小数点，必须以中文、英文或数字开头" class="notes"></i>
                                <el-input v-model="ruleForm.funcName" placeholder="请输入您的功能名称"></el-input>
                            </el-form-item>
                            <el-form-item prop="identifier" label="标识符：" autocomplete="off" >
                                <i><img :src="notes" title="须介于1~32个字符之间，支持大小写字母、数字和下划线" class="notes"></i>
                                <el-input v-model="ruleForm.identifier" @input="ruleForm.identifier = ruleForm.identifier.replace(/[^\w]/g,'').replace(/^_/g,'')"></el-input>
                            </el-form-item>
                            <el-form-item prop="dataType" label="数据类型：" autocomplete="off" class="m-b-10">
                                <div class="func-select">
                                    <el-select v-model="ruleForm.dataType" placeholder="请选择">
                                        <el-option
                                          v-for="item in dataType"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                            <!-- int32 float double 类型 -->
                            <div v-if="ruleForm.dataType == 'int'||ruleForm.dataType == 'float'||ruleForm.dataType == 'double'">
                                <el-form-item prop="range" label="取值范围：" autocomplete="off" class="m-b-10 range">
                                    <el-input v-model="ruleForm.min" placeholder="最小值" @input="inputChange('min')"></el-input><span class="m-20">~</span>
                                    <el-input v-model="ruleForm.max" placeholder="最大值" @input="inputChange('max')"></el-input>
                                </el-form-item>
                                <el-form-item prop="step" label="步长：" autocomplete="off" class="m-b-10">
                                    <el-input v-model="ruleForm.step" placeholder="请输入步长" @input="inputChange('step')"></el-input>
                                </el-form-item>
                                <el-form-item prop="define" label="数值定义：" autocomplete="off" class="m-b-10 w-100">
                                    <div class="define">
                                        下下限<span class="border-red"><el-input v-model="ruleForm.errorDown" @input="inputChange('errorDown')"></el-input></span>
                                        下限<span class="border-yellow"><el-input v-model="ruleForm.warnDown" @input="inputChange('warnDown')"></el-input></span>
                                        上限<span class="border-yellow"><el-input v-model="ruleForm.warnUp" @input="inputChange('warnUp')"></el-input></span>
                                        上上限<span class="border-red m-r-0"><el-input v-model="ruleForm.errorUp" @input="inputChange('errorUp')"></el-input></span>
                                    </div>
                                </el-form-item>
                                <el-form-item label="单位：" autocomplete="off" class="m-b-10">
                                    <div class="func-select">
                                        <el-select v-model="ruleForm.unit" filterable  placeholder="请选择">
                                            <el-option
                                              v-for="item in unitData"
                                              :key="item.Symbol"
                                              :label="`${item.Name+'/'+item.Symbol}`"
                                              :value="item.Symbol">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-form-item>
                            </div>
                            <!-- bool类型 -->
                            <div v-if="ruleForm.dataType == 'bool'">
                                <el-form-item prop="bool" label="布尔值：" autocomplete="off" class="m-b-10 bool">
                                    <p>0-<el-input v-model="ruleForm.boolFalse" placeholder="如：关"></el-input></p>
                                    <p>1-<el-input v-model="ruleForm.boolTrue" placeholder="如：开"></el-input></p>
                                </el-form-item>
                            </div>
                            <!-- date类型 -->
                            <div v-if="ruleForm.dataType == 'date'">
                                <el-form-item prop="" label="时间格式：" autocomplete="off" class="m-b-12 w-100" >
                                    <p><span class="date">String类型的UTC时间戳 (毫秒)</span> </p>
                                </el-form-item>
                            </div>
                            <!-- text类型 -->
                            <div v-if="ruleForm.dataType == 'text'">
                                <el-form-item prop="length" label="数据长度：" autocomplete="off" class="m-b-10" >
                                    <el-input v-model="ruleForm.length" class="length" @input="inputChange('length')"></el-input>
                                    <span class="text">字节</span>
                                </el-form-item>
                            </div>
                            <!-- 枚举型 -->
                            <div v-if="ruleForm.dataType == 'enum'">
                                <el-form-item prop="regEnum" label="枚举型" autocomplete="off" class="m-b-10 enum clearfix" >
                                    <p class="enum-title"><span>参数值 <i><img :src="notes" title="" class="notes"></i></span><span>参数描述<i><img :src="notes" title="" class="notes"></i></span></p>
                                    <div style="max-height: 180px; overflow: auto;">
                                      <div v-for="(enumObj,e) in enumData" :key="e" class="enum-box">
                                          <el-input v-model="enumObj.key" placeholder="编号如'0'"></el-input><span class="m-20">~</span>
                                          <el-input v-model="enumObj.value" placeholder="对该检举项的描述"></el-input>
                                          <span class="delAttr disabled2" v-if="e==0">删除</span>
                                          <span class="delAttr" @click="delEnum(e)" v-if="e!=0">删除</span>
                                      </div>
                                    </div>
                                    <span class="add-enum" @click="addEnum">+添加枚举项</span>
                                </el-form-item>
                            </div>
                            <el-form-item prop="accessMode" label="读写类型：" autocomplete="off" class="m-b-0">
                                <el-radio-group v-model="ruleForm.accessMode" class="nodeType">
                                    <el-radio :label=1>读写</el-radio>
                                    <el-radio :label=2>只读</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="产品功能描述：" class="m-b-10">
                                <el-input
                                type="textarea"
                                class="remarks"
                                v-model="ruleForm.note"
                                maxlength="256"
                                show-word-limit
                                id="addFuncRemarks"
                                placeholder="请输入内容">
                            </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <p class="btn-box"><el-button type="primary" @click="addFunc">确定</el-button> <el-button @click="close('addFuncShow')">取消</el-button></p>
                </div>
                <div class="popup-addFunc" v-show="editFuncShow">
                    <div class="popup-title">
                        {{$store.state.functionList.includes('productEdit')&&!$store.state.isLook?'编辑':'查看'}}功能<i class="el-icon-circle-close close" @click="close('editFuncShow')"></i>
                    </div>
                    <div class="poput-lab">
                        <el-form :model="ruleForm" :rules="rules" ref="editFunc" class="clearfix" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook">
                            <el-form-item prop="funcName" label="功能名称：" autocomplete="off" >
                                <i><img :src="notes" title="须介于1~32个字符之间，支持中文、大小写字母、数字、短划线、下划线和小数点，必须以中文、英文或数字开头" class="notes"></i>
                                <el-input v-model="ruleForm.funcName" placeholder="请输入您的功能名称"></el-input>
                            </el-form-item>
                            <el-form-item prop="identifier" label="标识符：" autocomplete="off" >
                                <i><img :src="notes" title="须介于1~32个字符之间，支持大小写字母、数字和下划线" class="notes"></i>
                                <el-input v-model="ruleForm.identifier" disabled></el-input>
                            </el-form-item>
                            <el-form-item prop="dataType" label="数据类型：" autocomplete="off" class="m-b-10">
                                <div class="func-select">
                                    <el-select v-model="ruleForm.dataType" placeholder="请选择" disabled>
                                        <el-option
                                          v-for="item in dataType"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                            <!-- int32 float double 类型 -->
                            <div v-if="ruleForm.dataType == 'int'||ruleForm.dataType == 'float'||ruleForm.dataType == 'double'">
                                <el-form-item prop="range" label="取值范围：" autocomplete="off" class="m-b-10 range">
                                    <el-input v-model="ruleForm.min" placeholder="最小值" @input="inputChange('min')"></el-input><span class="m-20">~</span>
                                    <el-input v-model="ruleForm.max" placeholder="最大值" @input="inputChange('max')"></el-input>
                                </el-form-item>
                                <el-form-item prop="step" label="步长：" autocomplete="off" class="m-b-10">
                                    <el-input v-model="ruleForm.step" placeholder="请输入步长" @input="inputChange('step')"></el-input>
                                </el-form-item>
                                <el-form-item prop="define" label="数值定义：" autocomplete="off" class="m-b-10 w-100">
                                    <div class="define">
                                        下下限<span class="border-red"><el-input v-model="ruleForm.errorDown" @input="inputChange('errorDown')"></el-input></span>
                                        下限<span class="border-yellow"><el-input v-model="ruleForm.warnDown" @input="inputChange('warnDown')"></el-input></span>
                                        上限<span class="border-yellow"><el-input v-model="ruleForm.warnUp" @input="inputChange('warnUp')"></el-input></span>
                                        上上限<span class="border-red m-r-0"><el-input v-model="ruleForm.errorUp" @input="inputChange('errorUp')"></el-input></span>
                                    </div>
                                </el-form-item>
                                <el-form-item label="单位：" autocomplete="off" class="m-b-10">
                                    <div class="func-select">
                                        <el-select v-model="ruleForm.unit" filterable  placeholder="请选择">
                                            <el-option
                                              v-for="item in unitData"
                                              :key="item.Symbol"
                                              :label="`${item.Name+'/'+item.Symbol}`"
                                              :value="item.Symbol">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-form-item>
                            </div>
                            <!-- bool类型 -->
                            <div v-if="ruleForm.dataType == 'bool'">
                                <el-form-item prop="bool" label="布尔值：" autocomplete="off" class="m-b-10 bool">
                                    <p>0-<el-input v-model="ruleForm.boolFalse" placeholder="如：关"></el-input></p>
                                    <p>1-<el-input v-model="ruleForm.boolTrue" placeholder="如：开"></el-input></p>
                                </el-form-item>
                            </div>
                            <!-- date类型 -->
                            <div v-if="ruleForm.dataType == 'date'">
                                <el-form-item prop="" label="时间格式：" autocomplete="off" class="m-b-12 w-100" >
                                    <p><span class="date">String类型的UTC时间戳 (毫秒)</span> </p>
                                </el-form-item>
                            </div>
                            <!-- text类型 -->
                            <div v-if="ruleForm.dataType == 'text'">
                                <el-form-item prop="length" label="数据长度：" autocomplete="off" class="m-b-10" >
                                    <el-input v-model="ruleForm.length" class="length" @input="inputChange('length')"></el-input>
                                    <span class="text">字节</span>
                                </el-form-item>
                            </div>
                            <!-- 枚举型 -->
                            <div v-if="ruleForm.dataType == 'enum'">
                            <el-form-item prop="regEnum" label="枚举型：" autocomplete="off" class="m-b-10 enum clearfix" >
                                <p class="enum-title"><span>参数值 <i><img :src="notes" title="" class="notes"></i></span><span>参数描述<i><img :src="notes" title="" class="notes"></i></span></p>
                                <div style="max-height: 180px; overflow: auto;">
                                  <div v-for="(enumObj,e) in enumData" :key="e" class="enum-box">
                                      <el-input v-model="enumObj.key" placeholder="编号如'0'"></el-input><span class="m-20">~</span>
                                      <el-input v-model="enumObj.value" placeholder="对该检举项的描述"></el-input>
                                      <span class="delAttr disabled2" v-if="e==0">删除</span>
                                      <span class="delAttr" @click="delEnum(e)" v-if="e!=0&&$store.state.functionList.includes('productEdit')&&!$store.state.isLook">删除</span>
                                  </div>
                                </div>
                                <span class="add-enum" @click="addEnum" v-show="$store.state.functionList.includes('productEdit')&&!$store.state.isLook">+添加枚举项</span>
                            </el-form-item>
                            </div>
                            <el-form-item prop="accessMode" label="读写类型：" autocomplete="off" class="m-b-0">
                                <el-radio-group v-model="ruleForm.accessMode" class="nodeType">
                                    <el-radio :label=1>读写</el-radio>
                                    <el-radio :label=2>只读</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="产品功能描述：" class="m-b-10">
                                <el-input
                                    type="textarea"
                                    class="remarks"
                                    v-model="ruleForm.note"
                                    maxlength="256"
                                    show-word-limit
                                    id="editFuncRemarks"
                                    placeholder="请输入内容">
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <p class="btn-box"><el-button type="primary" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook" @click="setFunction('editFunc')">确定</el-button> <el-button  @click="close('editFuncShow')">取消</el-button></p>
                </div>
                <div class="popup-import" v-if="importShow" style="width: 420px;">
                  <div class="popup-title">
                    {{importType==1?'导入产品功能':'导入报警规则'}}<i class="el-icon-circle-close close" @click="close('importShow')"></i>
                  </div>
                  <div class="poput-lab">
                    <el-upload
                      class="upload-demo"
                      drag
                      ref="importFileInput"
                      action="https://jsonplaceholder.typicode.com/posts/"
                      accept=".xls,.xlsx"
                      :limit='1'
                      :file-list="fileList"
                      :auto-upload="false"
                      :http-request="uploadXls"
                      :on-change="changeFileList"
                      :on-remove="()=>{fileList=[];errorTipShow=false}"
                      >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                  </div>
                  <div class="error-text">
                    <p v-show="errorTipShow">格式错误导入失败，请<a :href="downloadUrl" style="color: #409eff;">下载文件</a>并修改后重新上传！</p>
                  </div>
                    <p class="btn-box">
                      <el-button type="primary" :disabled="errorTipShow||!fileList.length||!$store.state.functionList.includes('productEdit')||$store.state.isLook" @click="importFunc">导入</el-button>
                      <el-button  @click="close('importShow')">取消</el-button>
                    </p>
                </div>

               <!-- <div class="popup-import" v-if="importRuleShow" style="width: 420px;">
                  <div class="popup-title">
                    <i class="el-icon-circle-close close" @click="close('importRuleShow')"></i>
                  </div>
                  <div class="poput-lab">
                    <el-upload
                      class="upload-demo"
                      drag
                      ref="importRuleFileInput"
                      action="https://jsonplaceholder.typicode.com/posts/"
                      accept=".xls,.xlsx"
                      :limit='1'
                      :file-list="fileList"
                      :auto-upload="false"
                      :http-request="uploadXls"
                      :on-change="changeFileList"
                      :on-remove="()=>{fileList=[]}"
                      >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                  </div>
                  <div class="error-text">
                    <p v-show="errorTipShow">格式错误导入失败，请<span style="color: #409eff;">下载文件</span>并修改后重新上传！</p>
                  </div>
                    <p class="btn-box">
                      <el-button type="primary" :disabled="!fileList.length||!$store.state.functionList.includes('productEdit')||$store.state.isLook" @click="importRule">导入2</el-button>
                      <el-button  @click="close('importRuleShow')">取消</el-button>
                    </p>
                </div> -->
            </div>
            <!-- 报警弹窗 -->
            <div class="popup">
                <div class="popup-addAlarm" v-show="addAlarmShow">
                    <div class="popup-title">
                        新建规则<i class="el-icon-circle-close close" @click="close('addAlarmShow')"></i>
                    </div>
                    <div class="poput-lab">
                        <el-form :model="ruleForm" :rules="rules" ref="addAlarm" class="clearfix" :disabled="!$store.state.functionList.includes('productEdit')">
                            <div class="alarm-left">
                                <el-form-item label="规则名称：" autocomplete="off" prop="WarnName">
                                    <i><img :src="notes" title="须介于1~32个字符之间，支持中文、大小写字母、数字、短划线、下划线和小数点，必须以中文、英文或数字开头" class="notes"></i>
                                    <el-input v-model="ruleForm.alarmName" placeholder="请输入您的规则名称"></el-input>
                                </el-form-item>
                                <el-form-item label="触发条件：" autocomplete="off" class="w-100 clearfix">
                                    <div class="trigger-box">
                                        <div class="condition-box clearfix" v-for="(trigger,t) in ruleForm.trigger">
                                            <p>触发条件{{t+1}}</p>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.property`" :rules="rules.trigger_property">
                                                <el-select v-model="trigger.property" :title="getTitle(trigger.property,proFunction.properties,'identifier')" placeholder="请选择" class="attribute" @change="setCompare($event,t,'trigger')">
                                                    <el-option
                                                    v-for="attrObj in proFunction.properties"
                                                    :key="attrObj.identifier"
                                                    :label="attrObj.name"
                                                    :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.compare`" :rules="rules.trigger_compare">
                                                <el-select v-model="trigger.compare" @change="setValue($event,t,'trigger')" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'int' || trigger.propertyData.type == 'float' || trigger.propertyData.type == 'double'">
                                                    <el-option :value=1 label=">"></el-option>
                                                    <el-option :value=2 label=">="></el-option>
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=4 label="<"></el-option>
                                                    <el-option :value=5 label="<="></el-option>
                                                    <el-option :value=6 label="!="></el-option>
                                                    <el-option :value=7 label="in"></el-option>
                                                    <el-option :value=8 label="between"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'bool' || trigger.propertyData.type == 'enum'">
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=9 label="pulse" v-show="trigger.propertyData.type == 'bool'"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.value`" :rules="rules.trigger_value">
                                                <el-input class="attribute" placeholder="请输入比较值" @input="regNumber(t,'value','trigger')" v-model="trigger.value" v-show="trigger.propertyData.type == 'int' || trigger.propertyData.type == 'float' || trigger.propertyData.type == 'double'"></el-input>
                                                <el-select v-model="trigger.value" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'bool' || trigger.propertyData.type == 'enum'">
                                                    <el-option
                                                    v-for="specsObj in trigger.propertyData.specs"
                                                    :key="specsObj.key"
                                                    :label="specsObj.value"
                                                    :value="specsObj.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <span class="delAttr" @click="deltrigger(1,t)" v-if="t!=0">删除</span>
                                            <span class="delAttr disabled2" v-if="t==0">删除</span>
                                        </div>
                                    </div>
                                    <div style="float: left;"><p class="add-enum" @click="addtrigger(1)">+新增触发条件</p></div>
                                </el-form-item>
                                <el-form-item label="报警条件：" autocomplete="off">
                                    <el-form-item label="" autocomplete="off" prop="duration">
                                        <div class="w-100 duration">
                                            <span>持续时间：</span><el-input @change="inputChange('duration')" v-model="ruleForm.duration" class="w-415"></el-input><span>秒</span>
                                        </div>
                                    </el-form-item>
                                    <div class="trigger-box">
                                        <div class="condition-box clearfix" v-for="(trigger,t) in ruleForm.triggerWarn">
                                            <p>报警条件{{t+1}}</p>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.property`" :rules="rules.triggerWarn_property">
                                                <el-select v-model="trigger.property"  :title="getTitle(trigger.property,proFunction.properties,'identifier')" placeholder="请选择" class="attribute" @change="setCompare($event,t,'triggerWarn')">
                                                    <el-option
                                                    label="无"
                                                    :value="null">
                                                    </el-option>
                                                    <el-option
                                                    v-for="attrObj in proFunction.properties"
                                                    :key="attrObj.identifier"
                                                    :label="attrObj.name"
                                                    :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.compare`" :rules="rules.triggerWarn_compare">
                                                <el-select v-model="trigger.compare" placeholder="请选择" @change="setValue($event,t,'triggerWarn')" class="attribute" v-show="trigger.propertyData.type == 'int' || trigger.propertyData.type == 'float' || trigger.propertyData.type == 'double'">
                                                    <el-option :value=1 label=">"></el-option>
                                                    <el-option :value=2 label=">="></el-option>
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=4 label="<"></el-option>
                                                    <el-option :value=5 label="<="></el-option>
                                                    <el-option :value=6 label="!="></el-option>
                                                    <el-option :value=7 label="in"></el-option>
                                                    <el-option :value=8 label="between"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'bool' || trigger.propertyData.type == 'enum'">
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=9 label="pulse" v-show="trigger.propertyData.type == 'bool'"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.value`" :rules="rules.triggerWarn_value">
                                                <el-input class="attribute" placeholder="请输入比较值" @input="regNumber(t,'value','triggerWarn')" v-model="trigger.value" v-show="trigger.propertyData.type == 'int' || trigger.propertyData.type == 'float' || trigger.propertyData.type == 'double'"></el-input>
                                                <el-select v-model="trigger.value" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'bool' || trigger.propertyData.type == 'enum'">
                                                    <el-option
                                                    v-for="specsObj in trigger.propertyData.specs"
                                                    :key="specsObj.key"
                                                    :label="specsObj.value"
                                                    :value="specsObj.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <span class="delAttr" @click="deltrigger(2,t)" v-if="t!=0">删除</span>
                                            <span class="delAttr disabled2" v-if="t==0">删除</span>
                                        </div>
                                    </div>
                                    <div style="float: left;"><p class="add-enum" @click="addtrigger(2)">+新增报警条件</p></div>
                                </el-form-item>
                            </div>
                            <div class="alarm-right">
                                <el-form-item label="报警类型：" class="checkbox" prop="typeSet">
                                    <div class="checkbox-box" v-if="ruleForm.typeSet">
                                        <el-checkbox-group v-model="ruleForm.typeSet">
                                            <el-checkbox v-for="type in warnData" :title="type.name" :key="type.id" :label="type.id" name="warntype">{{type.name}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </el-form-item>
                                <el-form-item label="报警级别：" autocomplete="off" class="m-b-0" prop="alarmLv">
                                    <el-radio-group v-model="ruleForm.alarmLv" class="nodeType">
                                        <el-radio :label=1>提示</el-radio>
                                        <el-radio :label=2>报警</el-radio>
                                        <el-radio :label=3>故障</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="备注：" class="m-t-20">
                                    <el-input
                                        type="textarea"
                                        class="remarks note"
                                        v-model="ruleForm.note"
                                        maxlength="256"
                                        id="addRuleRemarks"
                                        placeholder="请输入内容">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <p class="btn-box b-32"><el-button type="primary" @click="createAlarm('addAlarm')">确定</el-button> <el-button @click="close('addAlarmShow')">取消</el-button></p>
                </div>
                <div class="popup-addAlarm" v-show="editAlarmShow">
                    <div class="popup-title">
                        {{$store.state.functionList.includes('productEdit')&&!$store.state.isLook?'编辑':'查看'}}规则<i class="el-icon-circle-close close" @click="close('editAlarmShow')"></i>
                    </div>
                    <div class="poput-lab">
                        <el-form :model="ruleForm" :rules="rules" ref="editAlarm" class="clearfix" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook">
                            <div class="alarm-left">
                                <el-form-item label="规则名称：" autocomplete="off" prop="WarnName">
                                    <i><img :src="notes" title="须介于1~32个字符之间，支持中文、大小写字母、数字、短划线、下划线和小数点，必须以中文、英文或数字开头" class="notes"></i>
                                    <el-input v-model="ruleForm.alarmName" placeholder="请输入您的规则名称"></el-input>
                                </el-form-item>
                                <el-form-item label="触发条件：" autocomplete="off" class="w-100 clearfix">
                                    <div class="trigger-box">
                                        <div class="condition-box clearfix" v-for="(trigger,t) in ruleForm.trigger">
                                            <p>触发条件{{t+1}}</p>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.property`" :rules="rules.trigger_property">
                                                <el-select v-model="trigger.property" :title="getTitle(trigger.property,proFunction.properties,'identifier')" placeholder="请选择" class="attribute" @change="setCompare($event,t,'trigger')">
                                                    <el-option
                                                    v-for="attrObj in proFunction.properties"
                                                    :key="attrObj.identifier"
                                                    :label="attrObj.name"
                                                    :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.compare`" :rules="rules.trigger_compare">
                                                <el-select v-model="trigger.compare" @change="setValue($event,t,'trigger')" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'int' || trigger.propertyData.type == 'float' || trigger.propertyData.type == 'double'">
                                                    <el-option :value=1 label=">"></el-option>
                                                    <el-option :value=2 label=">="></el-option>
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=4 label="<"></el-option>
                                                    <el-option :value=5 label="<="></el-option>
                                                    <el-option :value=6 label="!="></el-option>
                                                    <el-option :value=7 label="in"></el-option>
                                                    <el-option :value=8 label="between"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'bool' || trigger.propertyData.type == 'enum'">
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=9 label="pulse" v-show="trigger.propertyData.type == 'bool'"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.value`" :rules="rules.trigger_value">
                                            <el-input class="attribute" placeholder="请输入比较值" @input="regNumber(t,'value','trigger')" v-model="trigger.value" v-show="trigger.propertyData.type == 'int' || trigger.propertyData.type == 'float' || trigger.propertyData.type == 'double'"></el-input>
                                                <el-select v-model="trigger.value" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'bool' || trigger.propertyData.type == 'enum'">
                                                    <el-option
                                                    v-for="specsObj in trigger.propertyData.specs"
                                                    :key="specsObj.key"
                                                    :label="specsObj.value"
                                                    :value="specsObj.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <span class="delAttr" @click="deltrigger(1,t)" v-if="t!=0">删除</span>
                                            <span class="delAttr disabled2" v-if="t==0">删除</span>
                                        </div>
                                    </div>
                                    <div style="float: left;"><p class="add-enum" @click="addtrigger(1)" v-show="$store.state.functionList.includes('productEdit')&&!$store.state.isLook">+新增触发条件</p></div>
                                </el-form-item>
                                <el-form-item label="报警条件：" autocomplete="off">
                                    <el-form-item label="" autocomplete="off" prop="duration">
                                        <div class="w-100 duration">
                                            <span>持续时间：</span><el-input @change="inputChange('duration')" v-model="ruleForm.duration" class="w-415"></el-input><span>秒</span>
                                        </div>
                                    </el-form-item>
                                    <div class="trigger-box">
                                        <div class="condition-box clearfix" v-for="(trigger,t) in ruleForm.triggerWarn">
                                            <p>报警条件{{t+1}}</p>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.property`" :rules="rules.triggerWarn_property">
                                                <el-select v-model="trigger.property"  :title="getTitle(trigger.property,proFunction.properties,'identifier')" placeholder="请选择" class="attribute" @change="setCompare($event,t,'triggerWarn')">
                                                    <el-option
                                                    label="无"
                                                    :value="null">
                                                    </el-option>
                                                    <el-option
                                                    v-for="attrObj in proFunction.properties"
                                                    :key="attrObj.identifier"
                                                    :label="attrObj.name"
                                                    :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.compare`" :rules="rules.triggerWarn_compare">
                                                <el-select v-model="trigger.compare" placeholder="请选择" @change="setValue($event,t,'triggerWarn')" class="attribute" v-show="trigger.propertyData.type == 'int' || trigger.propertyData.type == 'float' || trigger.propertyData.type == 'double'">
                                                    <el-option :value=1 label=">"></el-option>
                                                    <el-option :value=2 label=">="></el-option>
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=4 label="<"></el-option>
                                                    <el-option :value=5 label="<="></el-option>
                                                    <el-option :value=6 label="!="></el-option>
                                                    <el-option :value=7 label="in"></el-option>
                                                    <el-option :value=8 label="between"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'bool' || trigger.propertyData.type == 'enum'">
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=9 label="pulse" v-show="trigger.propertyData.type == 'bool'"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.value`" :rules="rules.triggerWarn_value">
                                                <el-input class="attribute" placeholder="请输入比较值" @input="regNumber(t,'value','triggerWarn')" v-model="trigger.value" v-show="trigger.propertyData.type == 'int' || trigger.propertyData.type == 'float' || trigger.propertyData.type == 'double'"></el-input>
                                                <el-select v-model="trigger.value" placeholder="请选择" class="attribute" v-show="trigger.propertyData.type == 'bool' || trigger.propertyData.type == 'enum'">
                                                    <el-option
                                                    v-for="specsObj in trigger.propertyData.specs"
                                                    :key="specsObj.key"
                                                    :label="specsObj.value"
                                                    :value="specsObj.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <span class="delAttr" @click="deltrigger(2,t)" v-if="t!=0">删除</span>
                                            <span class="delAttr disabled2" v-if="t==0">删除</span>
                                        </div>
                                    </div>
                                    <div style="float: left;"><p class="add-enum" @click="addtrigger(2)" v-show="$store.state.functionList.includes('productEdit')&&!$store.state.isLook">+新增报警条件</p></div>
                                </el-form-item>
                            </div>
                            <div class="alarm-right">
                                <el-form-item label="报警类型：" class="checkbox" prop="typeSet">
                                    <div class="checkbox-box" v-if="ruleForm.typeSet">
                                        <el-checkbox-group v-model="ruleForm.typeSet">
                                            <el-checkbox v-for="type in warnData" :key="type.id" :label="type.id" name="warntype">{{type.name}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </el-form-item>
                                <el-form-item label="报警级别：" autocomplete="off" class="m-b-0" prop="alarmLv">
                                    <el-radio-group v-model="ruleForm.alarmLv" class="nodeType">
                                        <el-radio :label=1>提示</el-radio>
                                        <el-radio :label=2>报警</el-radio>
                                        <el-radio :label=3>故障</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="备注：" class="m-t-20">
                                    <el-input
                                        type="textarea"
                                        class="remarks note"
                                        v-model="ruleForm.note"
                                        maxlength="256"
                                        id="editRuleRemarks"
                                        placeholder="请输入内容">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <p class="btn-box b-32"><el-button type="primary" :disabled="!$store.state.functionList.includes('productEdit')||$store.state.isLook" @click="updateAlarm('editAlarm')">确定</el-button> <el-button @click="close('editAlarmShow')">取消</el-button></p>
                </div>
            </div>
            <!-- 排序弹窗 -->
            <div class="popup">
              <div class="popup-paixu" v-show="paixuShow">
                    <div class="popup-title">
                        属性排序<i class="el-icon-circle-close close" @click="close('paixuShow')"></i>
                    </div>
                    <div class="poput-lab h-500">
                      <sortable v-for="(attr,a) in pxList" :key="a" :index="a" :options = "{animation:150}" v-model="dragData" class="sort-list" @sortend="sortend($event, pxList)" @mouseover.native="showBtnIndex=a">
                        <!-- <div class="sortItem" @hover="showBtnIndex=a"> -->
                          <span>{{attr.name}}</span>
                          <span class="icon-box" v-show="showBtnIndex==a">
                            <img :src="di" @click="rearrange(pxList, a, pxList.length-1)">
                            <img :src="ding" @click="rearrange(pxList, a, 0)">
                          </span>
                        <!-- </div> -->
                      </sortable>
                    </div>
                    <p class="btn-box b-32"><el-button type="primary" @click="sortAtrr">确定</el-button> <el-button @click="close('paixuShow')">取消</el-button></p>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import Sortable from 'vue-drag-sortable'
import Pagination from "@/components/PublicAssembly/pagination"
import unit from "@/assets/js/unit.json"
import dataType from "@/assets/js/dataType.json"
export default {
    components:{
        Sortable,
        Pagination,
    },
    data() {
        var valiName = (rule, value, callback) =>{      //产品名称
            value=value?value:'';
            if(value.length==0){
                callback(new Error('请输入产品名称'));
            }else if(value.length>32){
                callback(new Error('产品名称由1~32个字符构成'));
            }else{
                callback()
            }
            // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            // if(value == "" ||value==null){
            //     callback(new Error('产品名称不能为空'));
            // }else if(!reg.test(value)){
            //     callback(new Error('请输入中文、英文字母、数字和下划线，由1~32个字符构成'));
            // }else{
            //     callback();
            // }
        }
        var valiWarnName = (rule, value, callback) =>{  //规则名称
            value=this.ruleForm.alarmName;
            let isTrue =true
            let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(value == "" ||value==null){
                callback(new Error('请输入规则名称，不能为空'));
            }else if(value.length>32){
                callback(new Error('规则名称由1~32个字符构成'));
            }else{
                if(this.addAlarmShow){
                    for(let obj of this.productAlarm){
                        if(value == obj.name){
                            callback(new Error('同产品内报警名称不可重复'))
                            isTrue = false
                        }
                    }
                }else{
                    for(let i in this.productAlarm){
                        if(value == this.productAlarm[i].name && i!=this.nowAlarmIndex){
                            callback(new Error('同产品内报警名称不可重复'))
                            isTrue = false
                        }
                    }
                }
                if(isTrue){
                    callback()
                }
            }
        }
        var valiFuncName = (rule, value, callback) =>{  //功能名称
            let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}[A-Za-z0-9-_\u4e00-\u9fa5.]*$/;
            let isTrue = true
            if(value == "" ||value==null){
                callback(new Error('功能名称不能为空'));
                isTrue = false
            }else if(!reg.test(value)){
                callback(new Error('支持中文、大小写字母、数字、短划线、下划线和小数点，必须以中文、英文或数字开头,最多32位'));
                isTrue = false
            }else{
                if(this.addFuncShow){
                    for(let obj of this.proFunction.properties){
                        if(value == obj.name){
                            callback(new Error('同产品内功能名称不可重复'))
                            isTrue = false
                        }
                    }
                }else{
                    for(let i in this.proFunction.properties){
                        if(value == this.proFunction.properties[i].name && i!=this.nowFunction){
                            callback(new Error('同产品内功能名称不可重复'))
                            isTrue = false
                        }
                    }
                }
            }
            if(isTrue){
                callback()
            }
        }
        var identifier = (rule, value, callback) =>{    //功能标识符
            let reg=/^[A-Za-z0-9-_]{1,32}$/;
            if(this.editFuncShow){callback();}
            if(value == "" ||value==null){
                callback(new Error('功能标识符不能为空'));
            }else if(!reg.test(value)){
                callback(new Error('须介于1~32个字符之间，支持大小写字母、数字和下划线'));
            }else if(this.RegIdentifier(value)){
                callback(new Error('标识符重复，请重新输入'));
            }else{
                callback();
            }
        }
        var range = (rule, value, callback) =>{         //功能数据范围
            let reg;
            let max =this.ruleForm.max?Number(this.ruleForm.max):null,min=this.ruleForm.min?Number(this.ruleForm.min):null
            if(min=="" && min!=0||min==null){
                callback(new Error('请输入最小值'));
            }else if(max=="" && min!=0||max==null){
                callback(new Error('请输入最大值'));
            }else if(max < min){
                callback(new Error('最大值不能小于最小值'));
            }else if(max < min){
                callback(new Error('最大值不能小于最小值'));
            }else if(this.ruleForm.dataType =='float' && min < 0 && Math.abs(min)>1.175494351e+38||max > 3.402823466e+38){
                    callback(new Error('取值范围：-1.17E38～3.4E38'));
            }else if(this.ruleForm.dataType =='double' && min < 0 && Math.abs(min) > 1.7976931348623158e+308||max > 1.7976931348623158e+308 ||min > 1.7976931348623158e+307){
                    callback(new Error('取值范围：-2^128 ~ 2^128,double类型支持最大位数为64'));
            }else{
                callback();
            }
        }
        var step = (rule, value, callback) =>{          //步长
            let reg = /^(\d+)(\.\d+)?$/;
            let max = this.ruleForm.max,min=this.ruleForm.min
            value=Number(value)
            if(value == "" && value!=0 || value==null ||value==0){
                callback(new Error('步长不能为空或0'));
            }else if(!reg.test(value)){
                callback(new Error('步长格式错误，请输入正数'));
            }else if(max!=null && value>max){
                callback(new Error('步长超出取值范围'));
            }else{
                callback();
            }
            // else if((max-min)%value!=0){
            //     callback(new Error('步长'));
            // }
        }
        var define = (rule, value, callback) =>{        //数据定义
            let warnUp = this.ruleForm.warnUp;     //上限
            let warnDown = this.ruleForm.warnDown;      //下限
            let errorUp = this.ruleForm.errorUp;//上上限
            let errorDown = this.ruleForm.errorDown;//下下限
            let max = this.ruleForm.max,min=this.ruleForm.min
            let isTrue = true;
            if(max!=null && min!=null && (errorDown!=null && errorDown!="") && (errorDown>Number(max) || errorDown<Number(min))){
                callback(new Error('下下限超出取值范围'));
            }else if(max!=null && min!=null && (warnDown!=null && warnDown!="") && (warnDown>Number(max) || warnDown<Number(min))){
                callback(new Error('下限超出取值范围'));
            }else if(max!=null && min!=null && (warnUp!=null && warnUp!="") && (warnUp>Number(max) || warnUp<Number(min))){
                callback(new Error('上限超出取值范围'));
            }else if(max!=null && min!=null && (errorUp!=null && errorUp!="") && (errorUp>Number(max) || errorUp<Number(min))){
                callback(new Error('上上限超出取值范围'));
            }else if(warnDown!="" && warnDown !=null && errorDown!="" && errorDown !=null && Number(errorDown)>Number(warnDown)){
                callback(new Error('下下限需小于或等于下限'));
            }else if(warnDown!="" && warnDown !=null && warnUp!="" && warnUp !=null && Number(warnDown)>Number(warnUp)){
                callback(new Error('下限需小于或等于上限'));
            }else if(warnUp!="" && warnUp !=null && errorUp!="" && errorUp !=null && Number(warnUp)>Number(errorUp)){
                callback(new Error('上限需小于或等于上上限'));
            }else if(errorUp!="" && errorUp !=null && errorDown!="" && errorDown !=null && Number(errorDown)>Number(errorUp)){
                callback(new Error('下下限需小于或等于上上限'));
            }else if(warnUp!="" && warnUp !=null && errorDown!="" && errorDown !=null && Number(errorDown)>Number(warnUp)){
                callback(new Error('下下限需小于或等于上限'));
            }else if(errorUp!="" && errorUp !=null && warnDown!="" && warnDown !=null && Number(warnDown)>Number(errorUp)){
                callback(new Error('下限需小于或等于上上限'));
            }else {
                callback();
            }
        }
        var bool = (rule, value, callback) =>{          //布尔型描述
            if(this.ruleForm.boolFalse==""){
                callback(new Error('请输入值为0的描述'));
            }else if(this.ruleForm.boolTrue==""){
                callback(new Error('请输入值为1的描述'));
            }else{
                callback()
            }
        }
        var regEnum = (rule, value, callback) =>{       //枚举型
            let isTrue = true;
            let i=0;
            for(i in this.enumData){
                if(this.enumData[i].key==""){
                    callback(new Error(`第${Number(i)+1}枚举项的参数值不能为空`));
                    isTrue = false
                }else if(this.enumData[i].value==""){
                    callback(new Error(`第${Number(i)+1}枚举项的参数描述不能为空`));
                    isTrue = false
                }
                if(this.enumData.length == 1 && isTrue){
                    callback()
                }
                // //不存在空值则判断是否有重复枚举项
                if(isTrue){
                    let index = Number(i) + 1;
                    if(index >= this.enumData.length){
                        return
                    }
                    for(index;index<this.enumData.length;index++){
                        if(this.enumData[i].key==this.enumData[index].key){
                            callback(new Error(`第${Number(i)+1}枚举项的参数值与第${Number(index)+1}枚举项的参数值重复`));
                            isTrue = false
                            return
                        }else if(this.enumData[i].value==this.enumData[index].value){
                            callback(new Error(`第${Number(i)+1}枚举项的参数描述与第${Number(index)+1}枚举项的参数描述重复`));
                            isTrue = false
                            return
                        }else if(index==this.enumData.length-1&&isTrue){
                            callback();
                        }
                    }
                }
            }
        }
        var valitrigger = (rule, value, callback) =>{   //验证触发条件
            let i = 0
            let isTrue = true;
            for( let regObj of this.ruleForm.trigger){
                i++
                if(i>1&&regObj.property == null&&regObj.compare == null&&(regObj.value == null || regObj.value == "")){
                    callback();
                }
                if(regObj.property == null){
                    callback(new Error(`请选择触发条件${i}的属性`));
                    isTrue = false;
                }else if(regObj.compare == null){
                    callback(new Error(`请选择触发条件${i}的比较模式`));
                    isTrue = false;
                }else if(regObj.value == null || regObj.value == ""){
                    callback(new Error(`触发条件${i}的比较值不能为空`));
                    isTrue = false;
                }else if(regObj.compare == 8){
                    let str = regObj.value
                    str = str.substr(0,str.length-1).substr(1,str.length-1)
                    if(str=="" || str.indexOf(",") == -1 ||str.indexOf(",") == str.length-1){
                        callback(new Error(`触发条件${i}的比较值格式错误,格式:[1,2]`));
                        isTrue = false;
                    }else{
                        let arr = str.split(",")
                        if(arr.length!=2){
                            callback(new Error(`触发条件${i}的比较值格式错误,格式:[1,2]`));
                            isTrue = false;
                        }else if(Number(arr[0])>Number(arr[1]) || Number(arr[0])<regObj.propertyData.specs.min || Number(arr[1])>regObj.propertyData.specs.max){
                            callback(new Error(`触发条件${i}的比较值错误,第一个值需小于第二个值，且不能超出属性定义范围`));
                            isTrue = false;
                        }
                    }
                }else if(regObj.compare == 7){
                    let str = regObj.value
                    str = str.substr(0,str.length-1).substr(1,str.length-1)
                    if(str=="" ||str.indexOf(",") == str.length-1){
                        callback(new Error(`触发条件${i}的比较值格式错误,格式:[1,2]`));
                        isTrue = false;
                    }else{
                        let arr = str.split(",")
                        for(let index in arr){
                            if(Number(arr[index])>Number(regObj.propertyData.specs.max) || Number(arr[index])<Number(regObj.propertyData.specs.min)){
                                callback(new Error(`触发条件${i}的比较值错误,第${Number(index)+1}个值超出属性定义范围`));
                                isTrue = false;
                            }
                        }
                    }
                }else if(regObj.propertyData.type != "bool" ||regObj.propertyData.type != "enum" && regObj.compare == 7 ||regObj.compare == 8){
                    if(Number(regObj.value)>Number(regObj.propertyData.specs.max) || Number(regObj.value)<Number(regObj.propertyData.specs.min)){
                        callback(new Error(`触发条件${i}的比较值错误,值超出属性定义范围`));
                        isTrue = false;
                    }
                }
            }
            if(isTrue){
                callback()
            }
        }
        var valitriggerWarn = (rule, value, callback) =>{   //验证报警条件
            let i = 0
            let isTrue = true;
            for( let regObj of this.ruleForm.triggerWarn){
                i++
                if(this.ruleForm.triggerWarn.length==1&&(regObj.property == null||regObj.property=="")&&(regObj.value == null||regObj.value=="")){
                    callback()
                }
                if(regObj.property == null){
                    callback(new Error(`请选择报警条件${i}的属性`));
                    isTrue = false;
                }else if(regObj.compare == null){
                    callback(new Error(`请选择报警条件${i}的比较模式`));
                    isTrue = false;
                }else if(regObj.value == null || regObj.value == ""){
                    callback(new Error(`报警条件${i}的比较值不能为空`));
                    isTrue = false;
                }else if(regObj.compare == 8){
                    let str = regObj.value
                    str = str.substr(0,str.length-1).substr(1,str.length-1)
                    if(str=="" || str.indexOf(",") == -1 ||str.indexOf(",") == str.length-1){
                        callback(new Error(`报警条件${i}的比较值格式错误,格式:[1,2]`));
                        isTrue = false;
                    }else{
                        let arr = str.split(",")
                        if(arr.length!=2){
                            callback(new Error(`报警条件${i}的比较值格式错误,格式:[1,2]`));
                            isTrue = false;
                        }else if(Number(arr[0])>Number(arr[1]) || Number(arr[0])<regObj.propertyData.specs.min || Number(arr[1])>regObj.propertyData.specs.max){
                            callback(new Error(`报警条件${i}的比较值错误,第一个值需小于第二个值，且不能超出属性定义范围`));
                            isTrue = false;
                        }
                    }
                }else if(regObj.compare == 7){
                    let str = regObj.value
                    str = str.substr(0,str.length-1).substr(1,str.length-1)
                    if(str=="" ||str.indexOf(",") == str.length-1){
                        callback(new Error(`报警条件${i}的比较值格式错误,格式:[1,2]`));
                        isTrue = false;
                    }else{
                        let arr = str.split(",")
                        for(let index in arr){
                            if(Number(arr[index])>Number(regObj.propertyData.specs.max) || Number(arr[index])<Number(regObj.propertyData.specs.min)){
                                callback(new Error(`报警条件${i}的比较值错误,第${Number(index)+1}个值超出属性定义范围`));
                                isTrue = false;
                            }
                        }
                    }
                }else if(regObj.propertyData.type != "bool" ||regObj.propertyData.type != "enum" && regObj.compare == 7 ||regObj.compare == 8){
                    if(Number(regObj.value)>Number(regObj.propertyData.specs.max) || Number(regObj.value)<Number(regObj.propertyData.specs.min)){
                        callback(new Error(`报警条件${i}的比较值错误,值超出属性定义范围`));
                        isTrue = false;
                    }
                }
            }
            if(isTrue){
                callback()
            }
        }
        var valiWarnProperty=  (rule, value, callback) =>{
            callback()
        }
        var valiWarnCompare=  (rule, value, callback) =>{
            let obj = this.ruleForm.triggerWarn[rule.field.charAt(12)]
            if(obj.property==null||obj.property==''){
                callback()
            }else{
                if(obj.compare==''||obj.compare==null){
                    callback(new Error('比较值不能为空'))
                }else{
                    callback()
                }
            }
        }
        var valiWarnValue=  (rule, value, callback) =>{
            let obj = this.ruleForm.triggerWarn[rule.field.charAt(12)]
            if(obj.property==null||obj.property==''){
                callback()
            }else{
                if(obj.value==''||obj.value==null){
                    callback(new Error('比较值不能为空'))
                }else{
                    callback()
                }
            }
        }
        var validuration= (rule, value, callback) =>{
            if(Number(this.ruleForm.duration)>2592000||Number(this.ruleForm.duration)<0){
                callback(new Error('持续时间超出范围，范围：0~2592000'));
            }else if(this.ruleForm.duration!=0&&(this.ruleForm.duration ==''||this.ruleForm.duration ==null)){
                callback(new Error('请输入持续时间'))
            }else{
                callback()
            }
        }
        return {
            totalCount:0,   //分页
            pageSize:0,
            pageNumber:1,
            categoryData:[],  //产品类别数据
            selectCategoryData:[{id: "",name: "全部"}],    //筛选所用的分类数据
            productData:[],     //产品数据
            allProductData:[],  //所有产品数据
            optionProps: {
                value: 'id',
                label: 'name',
                children: 'children',
                expandTrigger: 'hover',
                code:"",
            },
            showBtnIndex:null,
            dataList:[],    //列表数据
            noGet:false,
            searchVal:"",   //搜索
            categoryId:["",0],
            notes:require('@/assets/image/organize/notes.png'),
            right:require('@/assets/image/index/right.png'),
            nullData:require('@/assets/image/index/nullData.png'),
            sx:require('@/assets/image/paixu/sx.png'),
            di:require('@/assets/image/paixu/di.png'),
            ding:require('@/assets/image/paixu/ding.png'),
            back:null,
            delProShow:false,
            addProShow:false,
            editProShow:false,
            cascaderKey:1,
            listShow:true,
            addFuncShow:false,
            editFuncShow:false,
            addAlarmShow:false,
            editAlarmShow:false,
            delProWarnShow:false,
            delProFuncShow:false,
            fileList:[],  //文件列表
            importShow:false,
            importType:1, //1 功能 2 报警
            importId:null,
            downloadUrl:null,
            errorTipShow:false,
            setProShow:false,
            paixuShow:false,
            pxList:[],
            dragData:{},
            ruleForm:{      //表单验证
                name:"",
                categoryId:null,
                categoryName:null,
                nodeType:2,
                note:'',
                cloneId:null,
                file:require('@/assets/image/company/logo.png'),
                code:"",
                funcName:"",        //功能名
                identifier:"",      //功能标识符
                dataType:"int",     //数据类型
                accessMode:1,       //读写类型
                min:null,           //最大值
                max:null,           //最小值
                step:null,          //步长
                warnUp:null,    //上限
                warnDown:null,    //下限
                errorUp:null, //上上限
                errorDown:null, //下下限
                unit:null,          //单位
                length:"",          //数据长度
                boolFalse:"",       //布尔型 0 的描述
                boolTrue:"",        //布尔型 1 的描述
                alarmLv:1,          //报警级别
                alarmName:"",       //报警规则名称
                duration:0,         //持续时间
                trigger:[           //触发条件
                    {
                        property:null,
                        compare:null,
                        value:null,
                        propertyData:{
                            type:'int'
                        }
                    }
                ],
                triggerWarn:[           //报警条件
                    {
                        property:null,
                        compare:null,
                        value:null,
                        propertyData:{
                            type:'int'
                        }
                    }
                ],
                typeSet:[],         //报警类型编号集
                typeNameSet:"",     //报警类型名称集
                editProName:"",     //修改的产品名
            },
            verifyForm:{
                verifyCode:'',
            },
            rules:{
                name:[{validator: valiName, required: true, trigger: 'blur'}],
                categoryId:[{required: true, message:"产品类别不能为空", trigger: 'blur'}],
                nodeType:[{required: true, message:"请选择产品类型", trigger: 'blur'}],
                funcName:[{ required: true, message: '请输入功能名称', trigger: 'blur' },
                        { max: 32, message: '最大支持32个字符', trigger: 'blur' }],
                identifier:[{validator: identifier, required: true, trigger: 'blur'}],
                dataType:[{required: true}],
                range:[{validator: range, required: true, trigger: 'blur'}],
                step:[{validator: step, required: true, trigger: 'blur'}],
                bool:[{validator: bool, required: true, trigger: 'blur'}],
                accessMode:[{required: true}],
                length:[{required: true, message:"请输入字符串长度", trigger: 'blur'}],
                regEnum:[{validator: regEnum, required: true, trigger: 'blur'}],
                define:[{validator: define, required: false, trigger: 'blur'}],
                WarnName:[{validator: valiWarnName, required: true, trigger: 'blur'}],
                trigger:[{validator: valitrigger, required: true, trigger: 'blur'}],
                triggerWarn:[{validator: valitriggerWarn, required: false, trigger: 'blur'}],
                typeSet:[{required: false, message:"请选择报警类型", trigger: 'blur'}],
                alarmLv:[{required: true, message:"请选择报警级别", trigger: 'blur'}],
                duration:[{required: true,validator: validuration, trigger: 'blur'}],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }],
                trigger_property:[{required: true, message:"请选择属性", trigger: 'change'}],
                trigger_compare:[{required: true, message:"请选择比较模式", trigger: 'change'}],
                trigger_value:[{required: true, message:"比较值不能为空", trigger: 'blur'}],
                triggerWarn_property:[{required: false, validator: valiWarnProperty, trigger: 'change'}],
                triggerWarn_compare:[{required: false, validator: valiWarnCompare, trigger: 'change'}],
                triggerWarn_value:[{required: false, validator: valiWarnValue, trigger: 'blur'}],
            },
            nowIndex:null,  //当前操作的产品下标
            nowObj:{        //当前操作的产品对象
                name:''
            },
            nowFunction:{}, //当前操作的产品功能
            nowProObj:{},
            active:0,
            proFunction:{
                properties:[]
            },
            dataType:[],    //数据类型
            unitData:[],    //单位数据
            enumData:[
                {key:'',value:''}
            ],
            setProObj:{},
            productAlarm:[],    //报警规则数据
            compareData:[       //比较模式
                {value:1,label:">"},
                {value:2,label:">="},
                {value:3,label:"=="},
                {value:4,label:"<"},
                {value:5,label:"<="},
                {value:6,label:"!="},
                {value:7,label:"in"},
                {value:8,label:"between"},
                {value:10,label:"unchange"}
            ],
            cascaderShow:false,
            condition:"",
            compare:"",
            warnData:[],        //报警分类
            nowAlarm:{},        //当前操作规则对象
            nowAlarmIndex:null,   //当前操作规则对象下标
            isCount:true,
            functionShow:false,
            VerifyArr:[],
            verifyCode:'',
            second:60,
            getCodeShow:true,
            countdownShow:false,
            phone:'',
            time:null,
            allCategory:[],
            showCodeArr:[],
            searchAttrVal:'',
            logo:require('@/assets/image/company/logo.png'),
        }
    },
    created() {
        this.back = require('@/assets/image/index/back'+this.cssType+'.png')
        this.$store.state.activeIndex = '/productList'
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.phone=this.hidePhone(this.$store.state.userData.mobile);
        this.getlist({pageNumber:1,length:this.pageSize});
        this.getProduct();
        this.unitData = unit;
        this.dataType = dataType;
        this.$store.state.mask=false
    },
    methods: {
      // 上传文件
      uploadXls(e){
        console.log(e)
        this.importId=(Math.random()*1000000).toFixed(0)+1
        // this.importId=new Date().getTime()
        let parm={
          file:e.file,
          importId:this.importId,
          productId:this.nowProObj.id
        }
        let formData = new FormData(),url='/ProductAlarmRule/import';
        Object.keys(parm).map(key=>{
            formData.append(key,parm[key]);
        });
        if(this.importType==1){
          url='/ProductFeature/import'
        }
        this.postForm(url,formData).then(res=>{
          if(res.success){
            this.importId=null
            this.errorTipShow=false
            this.$store.state.mask=false
            this.importShow=false
            this.fileList=[]
            this.getProTsl(this.nowProObj.code)
            this.$message({
              type:"success",
              message:"导入成功"
            })
          }else{
            this.errorTipShow=true
            if(this.importType==1){
              this.downloadUrl = "/api/v1/ProductFeature/getErrorExcel?importId="+this.importId
            }else{
              this.downloadUrl = "/api/v1/ProductAlarmRule/getErrorExcel?importId="+this.importId
            }
          }
        })
      },
      download(event){
        event.preventDefault();
      },
      // 更新文件列表
      changeFileList(file,fileList){
        this.fileList=fileList
      },
      // 导入功能
      importFunc(){
        this.$refs.importFileInput.submit()
      },
      importRule(){
        this.$refs.importFileInput.submit()
      },
        //选择图片
        clickFile(name){
            let fileName = name + 'file';
            let imgName = name + 'Img';
            let tipName = name + 'logo';
            let inp = this.$refs[fileName];
            inp.click();
            let that = this;
            inp.onchange = function(e) {
                let fileList =that.$refs[fileName].files;   //获取上传文件
                let file = fileList[0];                     //文件参数
                let size = file.size/1024;                  //文件大小
                if(size/1000 > 2){
                    that.$refs[tipName].style.display='block'
                    return
                }else{
                    that.$refs[tipName].style.display='none'
                }
                const fileReader = new FileReader()
                fileReader.readAsDataURL(file)              //读取图片
                fileReader.addEventListener('load', function() {
                    this.logo = fileReader.result;          // 读取完成
                    that.ruleForm.file = fileReader.result
                    that.$refs[imgName].src = this.logo;    //修改logo
                })
            }

        },
        //验证标识符
        RegIdentifier(val){
          let isTrue = false
          for(let item of this.proFunction.properties){
            if(item.identifier==val){
              isTrue = true
            }
          }
          return isTrue
        },
        // 属性排序
        paixu(list){
          this.pxList=this.clone(list)
          this.paixuShow=true
          this.$store.state.mask=true
        },
        sortAtrr(){
          // console.log(this.pxList,this.proFunction)
          let tsl = {
            profile:this.proFunction.profile,
            properties:this.pxList
          }
          // console.log(tsl)
          this.postNoJson("/ProductFeature/set",tsl).then((res)=>{
              if(res.success){
                  this.$message({
                      message: '修改成功',
                      type: 'success'
                  });
                  this.proFunction = this.clone(tsl)
                  this.pxList = [],
                  this.paixuShow = false,
                  this.$store.state.mask = false
              }else{
                  this.$message({
                      message: `修改失败：${res.message}`,
                      type: 'warning'
                  });
              }
          })
        },
        // 获取两个下标
        sortend (e, list) {
          const { oldIndex, newIndex } = e;
          this.rearrange(list, oldIndex, newIndex);
        },
        // 处理数组函数
        rearrange (array, oldIndex, newIndex) {
          if (oldIndex > newIndex) {
            array.splice(newIndex, 0, array[oldIndex]);
            array.splice(oldIndex + 1, 1);
          }
          else {
            array.splice(newIndex + 1, 0, array[oldIndex]);
            array.splice(oldIndex, 1);
          }
        },

        // 搜索属性
        searchAttr(){
          // console.log(this.searchAttrVal)
        	let searchArr = this.getArrayByName(this.searchAttrVal)
        	this.showCodeArr = []
        	for(let obj of searchArr){
        		this.showCodeArr.push(obj.identifier)
        	}
          // console.log(this.showCodeArr)
        	this.$forceUpdate()
        },
        // 搜索过滤函数
        getArrayByName(val){
        	var result = [];
        	if(this.proFunction.properties.length < 1){
        		return;
        	}
        	for (var i in this.proFunction.properties) {
        		if ((this.checkStrContain(this.proFunction.properties[i].name,val)||this.checkStrContain(this.proFunction.properties[i].identifier,val)) && result.length<this.proFunction.properties.length) {
        			result.push(this.proFunction.properties[i])
        		}
        	}
        	return result
        },
        // 模糊搜索=》 匹配方法
        checkStrContain(i, j) {
        	if(i.indexOf(j)!=-1){
        		return true
        	}else if(i.search(new RegExp(j.trim().replace(/([,.+?:()*\[\]^$|{}\\-])/g, '\\$1'), 'i')) !== -1){
            return true
          }else{
        		return false
        	}
        },
        // 获取列表
        getlist(parm){
            this.get('/Product/query',parm).then((res)=>{
                if(res.success){
                    this.dataList=res.result.data;
                    if(this.dataList.length!=0){
                        this.nowObj = this.dataList[0];
                    }
                    if(this.isCount){
                        this.totalCount=res.result.totalCount;
                    }
                }else{
                    this.$message({
                        message: `获取列表数据失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //获取产品类别
        getProduct(){
            this.get('/ProductCategory/getList').then((res)=>{
                if(res.success){
                    this.categoryData=res.result;
                    this.allCategory = this.clone(this.categoryData)
                    this.productTree(this.categoryData);
                }
            }).then(()=>{
                this.cascaderShow=true
                this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
            })
        },
        //产品类别转树形数据
        productTree(data){
            /* data = this.clone(data)
            let tree = [],parent,children;
            for(parent of data){
                if(parent.parentId == 0){
                    parent.children = [];
                    tree.push(parent)
                }
            }
            for(children of data){
                for(parent of tree){
                    if(children.parentId == parent.id){
                        parent.children.push(children)
                    }
                }
            } */
            let tree = this.common.arrayToTree(data,'children')
            this.categoryData = tree;
            for(let item of tree){
              if(item.children){
                for(let chi of item.children){
                  if(!chi.children){
                    chi.disabled = true
                  }
                }
              }else{
                  item.disabled = true
              }
            }
            let treeObj = this.clone(tree)
            for(let item of treeObj){
                this.selectCategoryData.push(item)
            }
            console.log(tree)
            //
            this.getProlist()
        },
        //获取所有产品
        getProlist(){
            this.get('/Product/getList').then((res)=>{
              //res.result.map(item=>item.parentId =item.categoryId)
              this.allProductData=res.result;
                let data = this.clone(this.categoryData);
                console.log(this.categoryData)
                for(let item of data){
                  if(item.children){
                    for(let children of item.children){
                        if(children.children){
                          for(let categroy of children.children){
                            categroy.children=[]
                            for(let pro of this.allProductData){
                                if(pro.categoryId == categroy.id){
                                    categroy.children.push(pro)
                                }
                            }
                            if(categroy.children.length==0){
                              categroy.disabled = true
                            }
                          }
                        }
                    }
                  }
                }
                //let data = this.allProductData.concat(this.allCategory)
                this.productData = data
                console.log(data,this.productData)
            })
        },
        //获取产品code
        getProCode(){
            this.get('/Product/createCode').then((res)=>{
                this.ruleForm.code=res.result
            })
        },
        //获取产品tsl
        getProTsl(code){
            this.get('/ProductFeature/get',{code:code}).then((res)=>{
                // console.log(code)
                // this.proFunction=JSON.parse(JSON.stringify(res.result))
                if(res.success){
                    // console.log(typeof res.result)
                    this.proFunction=JSON.parse(res.result)
                    this.searchAttr()
                    // console.log(this.proFunction)
                }else{
                    this.$message({
                        type:'warning',
                        message:`获取产品物模型失败：${res.message}`
                    })
                }
            }).then(()=>{
                this.getapiAlarmRule();
            })
        },
        //获取产品报警规则
        getapiAlarmRule(){
            this.get('/ProductAlarmRule/getList',{productId:this.nowProObj.id}).then((res)=>{
                if(res.success){
                    // console.log(res.result)
                    this.productAlarm=res.result
                }
            }).then(()=>{
                this.getwarnData()
            })
        },
        //获取报警分类
        getwarnData(){
            this.get('/Dict/getListByType',{type:2}).then((res)=>{
                this.warnData=res.result
            })
        },
        //修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            let parm={
                pageNumber:pageObj.number,
                length:pageObj.size,
                keyword:this.searchVal,
                categoryId:this.categoryId[2]==0?"":this.categoryId[2]
            }
            this.getlist(parm);
        },
        //修改页数
        setNum(number){
            //主动修改页数不发送请求
            if(this.noGet){
                this.noGet=false;
                return;
            }
            this.pageNumber=number;
            let parm ={
                pageNumber:number,
                length:this.pageSize,
                keyword:this.searchVal,
                categoryId:this.categoryId[2]==0?"":this.categoryId[2]
            }
            this.getlist(parm);
        },
        //搜索
        search(){
            this.noGet = true;
            let parm = {
                pageNumber:this.pageNumber,
                length:this.pageSize,
                keyword:this.searchVal,
                categoryId:this.categoryId[2]==0?"":this.categoryId[2]
            }
            this.isCount = true
            this.getlist(parm);
        },
        //关闭弹窗
        close(name){
            this.verifyForm.verifyCode = ''
            this.$store.state.mask=false;
            this.ruleForm = this.$options.data().ruleForm;
            this.fileList=[]
            this[name]=false;
        },
        //打开弹窗
        operate(obj,name,i){
            if(name=='delProShow'&&obj.referenceCount!=0){
                return
            }
            if(name!=='editProShow'&&!this.$store.state.functionList.includes('productEdit')||name!='editProShow'&&this.$store.state.isLook){
                return
            }
            if(this.VerifyArr.includes(9)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('productEdit')){
                this.$store.state.mask = true
                this.functionShow=true
                return
            }
            this[name]=true;
            this.nowIndex = i;
            if(name=="editProShow"){
                this.get('/Product/get',{id:obj.id}).then(res=>{
                    if(res.success){
                        this.listShow=false;
                        this.active=0;
                        this.nowProObj = res.result
                        // this.setProObj = this.clone(obj);
                        this.$store.state.mask=false;
                        this.ruleForm.categoryId = this.nowProObj.categoryId;
                        this.ruleForm.editProName = this.nowProObj.name;
                        this.ruleForm.image = this.nowProObj.image;
                        this.logo = this.nowProObj.image;
                        this.ruleForm.note = this.nowProObj.note;
                        this.ruleForm.categoryName = this.nowProObj.categoryName;
                        this.getProTsl(this.nowProObj.code)
                        obj=this.clone(res.result)
                    }else{
                        this.$message({
                            type:'warning',
                            message:`获取产品数据失败：${res.message}`
                        })
                    }
                })
                return
            }
            this.nowObj = this.clone(obj);
            this.$store.state.mask=true;
            // console.log(this.nowObj == this.nowProObj)
        },
        //打开新建产品弹窗
        showAdd(){
            this.ruleForm=this.$options.data().ruleForm
            this.logo = require('@/assets/image/company/logo.png')
            this.$store.state.mask=true;
            this.addProShow = true;
            this.getProCode();
        },
        //修改所属产品类别
        setCategoryName(value){
          console.log(value)
            for(let obj of this.allCategory){
                if(obj.id == value[2]){
                    this.ruleForm.categoryName = obj.name
                    // console.log(obj.name)
                }
            }
        },
        //删除产品
        delPro(){
            this.get('/Product/remove',{id:this.nowObj.id}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.search()
                }else{
                    this.$message({
                        message: '删除失败',
                        type: 'warning'
                    });
                }
                this.delProShow=false;
                this.$store.state.mask=false;
            })
        },
        //新建产品
        addPro(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let parm={
                        name:this.ruleForm.name,
                        code:this.ruleForm.code,
                        file:this.ruleForm.file,
                        nodeType:this.ruleForm.nodeType,
                        categoryId:this.ruleForm.categoryId[2],
                        categoryName:this.ruleForm.categoryName,
                        note:this.ruleForm.note,
                    }
                    if(this.ruleForm.cloneId){
                        parm.cloneId = this.ruleForm.cloneId[3]
                    }
                    if(parm.file == this.logo){
                        parm.file = null
                    }else{
                        parm.file = this.dataURItoBlob(parm.file)
                    }
                    let formdata = new FormData();
                    Object.keys(parm).map(key=>{
                        formdata.append(key,parm[key]);
                    });
                    this.postForm('/Product/create',formdata).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '新建成功',
                                type: 'success'
                            });
                            this.search()
                            this.$store.state.mask=false;
                            this.addProShow=false
                        }else{
                            this.$message({
                                message: `新建失败:${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        //列表页
        tolist(){
            this.listShow = true;
            this.editProShow = false;
            this.$store.state.mask = false;
            this.ruleForm = this.$options.data().ruleForm;
        },
        //编辑产品页面的按钮点击事件
        setActive(i){
            this.active = i;
        },
        //复制
        copy(name){
            let copy = this.$refs[name];
            copy.select(); // 选择对象
            document.execCommand('Copy'); // 执行浏览器复制命令
            this.$message({
                type:'success',
                message:'复制成功'
            })
        },
        //添加功能
        addFunction(){
            this.$store.state.mask=true;
            this.addFuncShow=true;
            this.ruleForm = this.$options.data().ruleForm;
            this.enumData = this.$options.data().enumData;
        },
        // 导入功能
        importFunction(){
          this.errorTipShow=false
          this.importType =1
          this.$store.state.mask=true;
          this.importShow=true;
        },
         // 导入报警
        importRule(){
          this.errorTipShow=false
          this.importType =2
          this.$store.state.mask=true;
          this.importShow=true;
        },
        //编辑功能
        editFunc(item,i){
            this.$store.state.mask=true;
            this.editFuncShow=true;
            this.nowFunction=i;
            let type = item.dataType.type;
            this.ruleForm.funcName = item.name;
            this.ruleForm.identifier = item.identifier;
            this.ruleForm.accessMode = item.accessMode=="rw"?1:2;
            this.ruleForm.required='false';
            this.ruleForm.dataType = type;
            this.ruleForm.note = item.note;
            if(type=="bool"){
                this.ruleForm.boolFalse = item.dataType.specs['0']
                this.ruleForm.boolTrue = item.dataType.specs['1']
            }else if(type=="enum"){
                this.enumData = [];
                var that = this;
                Object.keys(item.dataType.specs).forEach(function(key){
                    let obj ={};
                    obj.key = key;
                    obj.value = item.dataType.specs[key];
                    that.enumData.push(obj);
                });
            }else if(type=="text"){
                this.ruleForm.length=item.dataType.specs.length
            }else{
                this.ruleForm.unit = item.dataType.specs.unit;
                this.ruleForm.step = item.dataType.specs.step;
                this.ruleForm.min = item.dataType.specs.min;
                this.ruleForm.max = item.dataType.specs.max;
                this.ruleForm.warnUp = item.dataType.warnUp;
                this.ruleForm.warnDown = item.dataType.warnDown;
                this.ruleForm.errorUp = item.dataType.errorUp;
                this.ruleForm.errorDown = item.dataType.errorDown;
            }
        },
        //清除数据定义中的{}"
        replaceSpecs( str ){
           try{
              return JSON.stringify(str).replace(/\s+|{|}|"/g, "")
           }catch(err){
             console.log(str)
             return "err"
           }
        },
        //添加枚举项
        addEnum(){
            let obj = {key:"",value:""};
            if(this.enumData.length < 50){
                this.enumData.push(obj);
            }
        },
        regNumber(i,regObj,name){
            if(this.ruleForm[name][i].compare==7||this.ruleForm[name][i].compare==8){
                this.ruleForm[name][i][regObj] = '['+this.ruleForm[name][i][regObj].replace(/[^\-?\d.,]/g,"").replace(/\[/g, "").replace(/\]/g, "").replace(/,,/g, ",")+']';
            }else{
                this.ruleForm[name][i][regObj] = this.ruleForm[name][i][regObj].replace(/[^\-?\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^\./g, "").replace(/--/g, "-").replace(/[\d]-/g,"");
            }
        },
        //删除枚举
        delEnum(i){
            this.enumData.splice(i,1);
        },
        //数字输入框值改变
        inputChange(regObj){
            if(regObj=="step"){
                if(this.ruleForm.dataType == 'int'){
                    this.ruleForm[regObj] = this.ruleForm[regObj].replace(/[^\d]/g,'');
                }else{
                    this.ruleForm[regObj] = this.ruleForm[regObj].replace(/[^\d.]/g,'').replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".");
                }
                return;
            }
            if(this.ruleForm.dataType=="text" ){
                this.ruleForm[regObj] = this.ruleForm[regObj].replace(/[^\d]/g,'');
            }else if(this.ruleForm.dataType == 'int'){
                this.ruleForm[regObj] = this.ruleForm[regObj].replace(/[^\-?\d]/g,'').replace(/--/g, "-").replace(/[\d]-/g,"");
            }else if(this.ruleForm.dataType == 'float'||this.ruleForm.dataType == 'double'){
                this.ruleForm[regObj] = this.ruleForm[regObj].replace(/[^\-?\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^\./g, "").replace(/--/g, "-").replace(/[\d]-/g,"");
            }else{
                this.ruleForm[regObj] = this.ruleForm[regObj].replace(/[^\d]/g,'');
            }
        },
        //添加定义功能
        addFunc(){
            this.$refs.addFunc.validate((valid) => {
                if(valid){
                    let parm = {
                        identifier:this.ruleForm.identifier,
                        name:this.ruleForm.funcName,
                        accessMode:this.ruleForm.accessMode==1?"rw":"r",
                        required:"false",
                        dataType:{
                            type:this.ruleForm.dataType,
                            specs:null,
                        }
                    }
                    let type =this.ruleForm.dataType;
                    if(type=='bool'){
                        parm.dataType.specs={
                            0:this.ruleForm.boolFalse,
                            1:this.ruleForm.boolTrue,
                        }
                    }else if(type=="text"){
                        parm.dataType.specs={
                            length:this.ruleForm.length,
                        }
                    }else if(type=="int"||type=="float"||type=="double"){
                        parm.dataType.specs={
                            min:this.ruleForm.min,
                            max:this.ruleForm.max,
                            unit:null,
                            unitName:null
                        }
                        //单位
                        if(this.ruleForm.unit!=null){
                            for(let obj of this.unitData){
                                if(this.ruleForm.unit == obj.Symbol){
                                    parm.dataType.specs.unit = obj.Symbol;
                                    parm.dataType.specs.unitName = obj.Name;
                                }
                            }
                        }
                        parm.dataType.warnUp=this.ruleForm.warnUp
                        parm.dataType.warnDown=this.ruleForm.warnDown
                        parm.dataType.errorUp=this.ruleForm.errorUp
                        parm.dataType.errorDown=this.ruleForm.errorDown
                        parm.dataType.specs.step=this.ruleForm.step
                    }else if(type="enum"){
                        let specs={};
                        for(let obj of this.enumData ){
                            specs[obj.key]=obj.value
                        }
                        parm.dataType.specs = specs
                    }else if(type="date"){
                        parm.dataType.specs ={}
                    }
                    parm.note=this.ruleForm.note
                    let tsl =this.clone(this.proFunction);
                    tsl.properties.push(parm);
                    // tsl=JSON.stringify(tsl)
                    this.postNoJson("/ProductFeature/set",tsl).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '新建成功',
                                type: 'success'
                            });
                            this.showCodeArr.push(parm.identifier)
                            this.proFunction.properties.push(parm);
                            this.$forceUpdate()
                            this.$store.state.mask=false;
                            this.addFuncShow=false;
                            this.ruleForm = this.$options.data().ruleForm;
                        }else{
                            this.$message({
                                message: `新建失败${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        // 修改功能
        setFunction(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let parm = {
                        identifier:this.ruleForm.identifier,
                        name:this.ruleForm.funcName,
                        accessMode:this.ruleForm.accessMode==1?"rw":"r",
                        required:"false",
                        dataType:{
                            type:this.ruleForm.dataType,
                            specs:null,
                        }
                    }
                    let type =this.ruleForm.dataType;
                    if(type=='bool'){
                        parm.dataType.specs={
                            0:this.ruleForm.boolFalse,
                            1:this.ruleForm.boolTrue,
                        }
                    }else if(type=="text"){
                        parm.dataType.specs={
                            length:this.ruleForm.length,
                        }
                    }else if(type=="int"||type=="float"||type=="double"){
                        parm.dataType.specs={
                            min:this.ruleForm.min,
                            max:this.ruleForm.max,
                            unit:null,
                            unitName:null
                        }
                        //单位
                        if(this.ruleForm.unit!=null){
                            for(let obj of this.unitData){
                                if(this.ruleForm.unit == obj.Symbol){
                                    parm.dataType.specs.unit = obj.Symbol;
                                    parm.dataType.specs.unitName = obj.Name;
                                }
                            }
                        }
                        parm.dataType.warnUp=this.ruleForm.warnUp
                        parm.dataType.warnDown=this.ruleForm.warnDown
                        parm.dataType.errorUp=this.ruleForm.errorUp
                        parm.dataType.errorDown=this.ruleForm.errorDown
                        parm.dataType.specs.step=this.ruleForm.step
                    }else if(type="enum"){
                        let specs={};
                        for(let obj of this.enumData ){
                            specs[obj.key]=obj.value
                        }
                        parm.dataType.specs = specs
                    }else if(type="date"){
                        parm.dataType.specs ={}
                    }
                    parm.note=this.ruleForm.note
                    let tsl = this.clone(this.proFunction);
                    tsl.properties[this.nowFunction]=parm;
                    // tsl = JSON.stringify(tsl)
                    this.postNoJson("/ProductFeature/set",tsl).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.proFunction.properties[this.nowFunction]=parm;
                        }else{
                            this.$message({
                                message: `修改失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                        this.$store.state.mask=false;
                        this.editFuncShow=false;
                        this.ruleForm = this.$options.data().ruleForm;
                    })
                }
            })
        },
        //删除功能
        delProFunc(){
            let parm = this.clone(this.proFunction)
            parm.properties.splice(this.nowIndex,1)
            this.postNoJson("/ProductFeature/set",parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.$store.state.mask=false;
                    this.delProFuncShow=false;
                    this.proFunction.properties.splice(this.nowIndex,1)
                }else{
                    this.$message({
                        message: `删除失败${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //新增报警规则弹窗
        addAlarm(){
            this.$store.state.mask=true;
            this.addAlarmShow=true
            this.$refs.addAlarm.clearValidate()
            this.nowFunction =null
        },
        //打开编辑规则弹窗
        editAlarm(item,i){
            this.nowAlarm = this.clone(item);
            this.nowAlarmIndex = i;
            this.ruleForm.alarmName = item.name;
            this.ruleForm.alarmLv = item.level;
            this.ruleForm.note = item.note;
            this.ruleForm.duration = item.duration?item.duration:0;
            this.ruleForm.typeSet = item.typeSet?item.typeSet.split(',').map(Number):[];
            let orCondition=[];
            let andCondition=[]
            if(item.orCondition){
                for(let trigger of item.orCondition){       //触发条件
                    if(!trigger.value||!trigger.property||!trigger.compare){
                        trigger={property:null,compare:null,value:null,propertyData:{type:'int'}}
                        orCondition.push(trigger)
                    }else{
                        trigger.value=String(trigger.value);
                        for(let property of this.proFunction.properties){
                            if(trigger.property== property.identifier){
                                trigger.propertyData={};
                                trigger.propertyData.type=property.dataType.type;
                                if(property.dataType.type=="bool"||property.dataType.type=="enum"){
                                    let arr = [];
                                    var that = this;
                                    Object.keys(property.dataType.specs).forEach(function(key){
                                        let obj ={};
                                        obj.key = key;
                                        obj.value = property.dataType.specs[key];
                                        arr.push(obj);
                                    });
                                    trigger.propertyData.specs=arr;
                                }else{
                                    trigger.propertyData.specs=property.dataType.specs
                                }
                                orCondition.push(trigger)
                            }
                        }
                    }
                }
            }else{
                orCondition = [{property:null,compare:null,value:null,propertyData:{type:'int'}}]
            }
            if(item.andCondition){
                for(let trigger of item.andCondition){      //报警条件
                    if(!trigger.value||!trigger.property||!trigger.compare){
                        trigger={property:null,compare:null,value:null,propertyData:{type:'int'}}
                        andCondition.push(trigger)
                    }else{
                        trigger.value=String(trigger.value);
                        for(let property of this.proFunction.properties){
                            if(trigger.property== property.identifier){
                                trigger.propertyData={};
                                trigger.propertyData.type=property.dataType.type;
                                if(property.dataType.type=="bool"||property.dataType.type=="enum"){
                                    let arr = [];
                                    var that = this;
                                    Object.keys(property.dataType.specs).forEach(function(key){
                                        let obj ={};
                                        obj.key = key;
                                        obj.value = property.dataType.specs[key];
                                        arr.push(obj);
                                    });
                                    trigger.propertyData.specs=arr;
                                }else{
                                    trigger.propertyData.specs=property.dataType.specs
                                }
                                andCondition.push(trigger)
                            }
                        }
                    }

                }
            }else{
                andCondition=[{property:null,compare:null,value:null,propertyData:{type:'int'}}]
            }
            this.ruleForm.trigger = orCondition
            this.ruleForm.triggerWarn = andCondition
            this.$store.state.mask=true;
            this.editAlarmShow=true;
            this.$refs.editAlarm.clearValidate()
        },
        //修改属性重置比较模式和比较值
        setCompare(val,i,name){
            this.ruleForm[name][i].compare=null;
            this.ruleForm[name][i].value=null;
            for(var obj of this.proFunction.properties){
                if(val == obj.identifier){
                    this.ruleForm[name][i].propertyData=this.clone(obj.dataType);
                    if(obj.dataType.type=="bool"||obj.dataType.type=="enum"){
                        let arr = [];
                        var that = this;
                        Object.keys(obj.dataType.specs).forEach(function(key){
                            let obj ={};
                            obj.key = key;
                            obj.value = that.ruleForm[name][i].propertyData.specs[key];
                            arr.push(obj);
                        });
                        that.ruleForm[name][i].propertyData.specs=arr;
                    }
                }
            }
        },
        //修改比较模式重置比较值
        setValue(val,i,name){
            this.ruleForm[name][i].value=null;
        },
        //添加条件
        addtrigger(i){
            let obj={
                property:null,
                compare:null,
                value:null,
                propertyData:{
                    type:'int'
                },
            }
            if(i==1){
                if(this.ruleForm.trigger.length==5){
                    this.$message({
                        message: '添加失败，触发条件最多5条',
                        type: 'warning'
                    });
                }else{
                    this.ruleForm.trigger.push(obj)
                }
            }else{
                if(this.ruleForm.triggerWarn.length==5){
                    this.$message({
                        message: '添加失败，报警条件最多5条',
                        type: 'warning'
                    });
                }else{
                    this.ruleForm.triggerWarn.push(obj)
                }
            }
        },
        //删除条件
        deltrigger(i,index){
            if(i==1){
                this.ruleForm.trigger.splice(index,1)
                if(this.addAlarmShow){
                    this.$refs.addAlarm.validateField("trigger")
                }else{
                    this.$refs.editAlarm.validateField("trigger")
                }
            }else{
                this.ruleForm.triggerWarn.splice(index,1)
            }
        },
        //创建报警规则
        createAlarm(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let typeData="",typeNameData="";
                    for(let id of this.ruleForm.typeSet){ //报警分类
                        for(let obj of this.warnData){
                            if(id==obj.id){
                                typeData += id+","
                                typeNameData += obj.name+","
                            }
                        }
                    }
                    typeData = typeData.substr(0,typeData.length - 1);
                    typeNameData = typeNameData.substr(0,typeNameData.length - 1);
                    let parm={
                        id:null,
                        productId:this.nowProObj.id,
                        name:this.ruleForm.alarmName,
                        typeSet:typeData,
                        typeNameSet:typeNameData,
                        level:this.ruleForm.alarmLv,
                        orCondition:[],
                        andCondition:[],
                        duration:this.ruleForm.duration,
                        note:this.ruleForm.note,
                    }
                    for(let orCondi of this.ruleForm.trigger){
                        let obj = {};
                        obj.property = orCondi.property;
                        obj.compare = orCondi.compare;
                        obj.value = orCondi.value;
                        if(obj.value&&obj.property&&obj.compare){
                            parm.orCondition.push(obj);
                        }
                    }
                    for(let andCondi of this.ruleForm.triggerWarn){
                        let obj = {};
                        obj.property = andCondi.property;
                        obj.compare = andCondi.compare;
                        obj.value = andCondi.value;
                        if(obj.value&&obj.property&&obj.compare){
                            parm.andCondition.push(obj);
                        }
                    }
                    if(parm.andCondition.length==0){
                        parm.andCondition=null
                    }
                    this.postNoJson('/ProductAlarmRule/create',parm).then((res)=>{
                        if(res.success){
                            parm.id=res.result;
                            this.productAlarm.unshift(parm)
                            this.$message({
                                message: '新建规则成功',
                                type: 'success'
                            });
                            this.ruleForm = this.$options.data().ruleForm;
                            this.addAlarmShow = false;
                            this.$store.state.mask=false;
                        }else{
                            this.$message({
                                message: `新建规则失败${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })

        },
        //删除报警规则
        delProWarn(){
            this.get('/ProductAlarmRule/remove',{id:this.nowObj.id}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.productAlarm.splice(this.nowIndex,1)
                }else{
                    this.$message({
                        message: `删除失败${res.message}`,
                        type: 'warning'
                    });
                }
                this.delProWarnShow = false;
                this.$store.state.mask=false;
            })
        },
        //编辑规则
        updateAlarm(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let typeData="",typeNameData="";
                    for(let id of this.ruleForm.typeSet){ //报警分类
                        for(let obj of this.warnData){
                            if(id==obj.id){
                                typeData += id+","
                                typeNameData += obj.name+","
                            }
                        }
                    }
                    typeData = typeData.substr(0,typeData.length - 1);
                    typeNameData = typeNameData.substr(0,typeNameData.length - 1);
                    let parm={
                        id:this.nowAlarm.id,
                        productId:this.nowProObj.id,
                        name:this.ruleForm.alarmName,
                        typeSet:typeData,
                        typeNameSet:typeNameData,
                        level:this.ruleForm.alarmLv,
                        orCondition:[],
                        andCondition:[],
                        duration:this.ruleForm.duration,
                        note:this.ruleForm.note,
                    }
                    for(let orCondi of this.ruleForm.trigger){
                        let obj = {};
                        obj.property = orCondi.property;
                        obj.compare = orCondi.compare;
                        obj.value = orCondi.value;
                        parm.orCondition.push(obj);
                    }
                    for(let andCondi of this.ruleForm.triggerWarn){
                        let obj = {};
                        obj.property = andCondi.property;
                        obj.compare = andCondi.compare;
                        obj.value = andCondi.value;
                        if(obj.value&&obj.property&&obj.compare){
                            parm.andCondition.push(obj);
                        }
                    }
                    if(parm.andCondition.length==0){
                        parm.andCondition=null
                    }
                    this.postNoJson('/ProductAlarmRule/update',parm).then((res)=>{
                        if(res.success){
                            this.productAlarm[this.nowAlarmIndex]=parm
                            this.$message({
                                message: '修改规则成功',
                                type: 'success'
                            });
                            this.ruleForm = this.$options.data().ruleForm;
                            this.editAlarmShow = false;
                            this.$store.state.mask=false;
                        }else{
                            this.$message({
                                message: `修改规则失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })

        },
        // 编辑产品弹窗
        setPro(){
            this.ruleForm = this.clone(this.nowProObj)
            this.logo = this.ruleForm.image
            // console.log(this.nowProObj)
            this.$store.state.mask=true;
            this.setProShow = true
        },
        //编辑产品
        editPro(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let parm = this.clone(this.ruleForm)
                    if(typeof parm.categoryId == 'object'){
                        parm.categoryId = parm.categoryId[2]
                    }
                    if(parm.cloneId&&typeof parm.cloneId == 'object'){
                        parm.cloneId = parm.cloneId[3]
                    }
                    parm.createdTime = this.changeDate(parm.createdTime);
                    if(parm.file == this.logo){
                      parm.file = null
                    }else if(parm.file){
                      parm.file = this.dataURItoBlob(parm.file)
                    }
                    let formdata = new FormData();
                    Object.keys(parm).map(key=>{
                      if(key=='cloneId'&&parm.cloneId){
                        formdata.append(key,parm[key]);
                      }else if(key!='cloneId'){
                        formdata.append(key,parm[key]);
                      }
                    });
                    this.postForm('/Product/update',formdata).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.$store.state.mask=false;
                            this.setProShow = false
                            this.get('/Product/get',{id:parm.id}).then((res)=>{
                                if(res.success){
                                    this.dataList[this.nowIndex]=res.result
                                    this.nowProObj = this.clone(res.result)
                                }
                            })
                        }else{
                            this.$message({
                                message: `修改失败:${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        // 获取验证码
        getCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }else{
                    this.$message({
                        message: `验证码发送失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            this.VerifyArr.splice(this.VerifyArr.indexOf(9),1)
                            localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            this.$store.state.mask=false
                            this.functionShow=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`提权失败：${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
        //获取产品所属分类
        getCategory(id){
            for(let obj of this.allCategory){
                if(obj.id==id){
                    for(let category of this.allCategory){
                        if(obj.parentId == category.id){
                            return  category.name+'/'
                        }
                    }
                }
            }
        },
        // 下拉框title
        getTitle(val,data,code){
            if(val&&data&&code){
                let result=data.filter(ele => ele[code] == val);
                if (result.length!=0) return result[0].name
            }
        }
    },
    watch: {
        cascaderKey(){
            ++this.cascaderKey;
        },
    },
}
</script>
<style scoped>
  .logoTip{
      position: absolute;
      top: 136px;
  }
  .red{
      color: #F56C6C;
      line-height: 20px;
      font-size: 14px;
      position: absolute;
      display: none;
  }
  .logo-box{
      position: relative;
      cursor: pointer;
  }
  .logo-box img{
      width: 96px;
      height: 96px;
      border-radius: 5px;
      margin-top: -35px;
      position: relative;
      z-index: 9;
  }
  .logo-box input{
    opacity: 0;
  }
  #product .popup .el-form-item.img{
    position: absolute;
    top:0px;
    right: 30px;
    width: 233px !important;
  }
  .icon-box{
    float: right;
    margin-right: 20px;
    padding-top: 5px;
    box-sizing: border-box;
    height: 44px;
    /* width: 80px; */
    cursor: pointer;
  }
  .icon-box img{
    margin: 0 5px;
    width: 14px;
  }
    .sortItem{
      width: 100%;
      border-bottom: 1px solid #f2f2f2;
    }
    .sort-list{
      line-height: 44px;
      font-size: 14px;
      border-bottom: 1px solid #f2f2f2;
      width: 402px;
      background-color: #fff;
    }
    .h-500{
      height: 500px;
      position: relative;
      overflow-y: auto;
      overflow-x: hidden;
    }
    /* 头部面包屑 */
    .breadcrumb{
        font-size: 16px;
        margin:0 20px;
        position: relative;
        z-index: 99;
        text-align: left;
    }
    .breadcrumb img{
      width: 18px;
      position: relative;
      top: 2px;
    }
    /* 列表 */
    .list-box,.editPro-box{
        position: absolute;
        top: 36px;
        left: 16px;
        right: 0;
        bottom: 0;
    }
    .list-top{
        margin: 0px 16px 15px 16px;
        padding-top: 24px;
        height: 34px;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .download-btn{
      padding: 9px 15px;
      font-size: 12px;
      border-radius: 3px;
      color: #fff;
      border: 1px solid #5087e4;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #5087e4;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin-left: 10px;
      transition: .1s;
      font-weight: 500;
    }
    .download-btn:hover{
      background: #376cc7!important;
      border-color: #376cc7!important;
      color: #fff;
    }
    .search{
        float: right;
        width: 388px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
    }
    .company-list{
        overflow: hidden;
        margin-bottom: 32px;
        height: 90%;
    }
    .scroll{
        overflow: auto;
        width: 97.6%;
        height: 88%;
        max-height: 88% !important;
        margin: 0 16px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .scroll>ul:last-child{
        border-bottom: 0;
    }
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 200px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-bottom:1px solid #f2f2f2 !important;
    }
    .w-18{
        width: 18% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    .w-90{
        width: 90px !important;
        margin-right: 20px !important;
    }
    .bg{
        background-color: #fff;
        width: 100%;
        height: 92%;
    }
    /* 弹窗 */
    .popup>div{
        position: fixed;
        top: 10%;
        left:50%;
        width: 577px;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-417px;
        background-color: #fff;
        z-index: 9999;
        padding-bottom: 30px;
        text-align: left;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 16px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px !important;
    }
    .btn-box{
        width: 100%;
        text-align: center;
    }
    .error-text{
      height: 30px;
      font-size: 12px;
      color: #F56C6C;
      line-height: 30px;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .px-btn{
      padding: 0 15px;
      line-height: 32px;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    img.notes{
        position: relative;
        left: 8px;
        top: 4px;
    }
    img.right{
        width: 12px;
        margin: 0 6px;
    }
    .popup-delPro{
        height: 284px;
    }
    .popup-addPro{
        width: 598px !important;
        height: 652px;
    }
    .editPro-box .bg{
        padding:0 27px;
        box-sizing: border-box;
        min-height: 744px;
    }
    .edit-top{
        line-height: 70px;
        text-align: left;
        font-size: 14px;
    }
    .edit-top p{
        float: left;
        margin-right: 78px;
    }
    .edit-top:first-child{
        margin-right: 0 !important;
    }
    .copy{
        color: #5087e4;
        cursor: pointer;
        margin-left: 20px;
    }
    .edit-btn-box{
        width: 330px;
        border-radius: 5px;
        overflow: hidden;
        cursor: pointer;
        margin-bottom: 25px;
        background-color: #f1f1f1;
    }
    .edit-btn-box div{
        width: 110px;
        color: #3a3a3a;
        font-size: 14px;
        float: left;
        height: 31px;
        padding-top: 9px;
    }
    .edit-btn-box span{
        display: inline-block;
        line-height: 22px;
        width: 110px;
        box-sizing: border-box;
        border-left: 1px solid #c2c2c2;
    }
    .active{
        background: #5087e4;
        color: #fff !important;
    }
    .active span{
        border: none !important;
    }
    .border-0{
        border: none !important;
    }
    .details{
        background: #fff;
        font-size: 14px;
        color: #606060;
        border: 1px solid #e5e5e5;
        border-radius: 5px;
    }
    .details span{
        display: inline-block;
        line-height: 44px;
        float: left;
    }
    .lab-title{
        background: #eeeeee !important;
        width: 8%;
    }
    .w-385{
        width: 24.27%;
    }
    .w-409{
        width: 25.78%;
    }
    .pro-details:last-child{
        border-top: none !important;
    }
    .border-b{
        border-bottom: 1px solid #e5e5e5 !important;
    }
    .lab-note{
        width: 59.7%;
        padding: 0 28px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .copy-obj{
        opacity: 0;
        position: fixed;
        top: 0;
        left: 0;
        z-index: -1;
    }
    .w-100{
        margin:16px 0 0 0!important;
        width: 100% !important;
    }
    .nodeType{
        margin-left: 10px;
    }
    .popup-addFunc{
        max-height: 880px;
        overflow: auto;
        top: -52px !important;
    }
    .popup-addAlarm{
        width: 90% !important;
        height: 702px;
        top: 0 !important;
        margin-left: -45% !important;
        max-width: 1200px;
    }
    .popup-paixu{
      height: 702px;
      width: 464px !important;
      overflow: hidden;
      top: 0 !important;
      /* margin-left: -45% !important; */
    }
    .alarm-left,.alarm-right{
        width: 44%;
        float: left;
    }
    .alarm-right{
        margin-left: 66px;
    }
    .range{
        display: block;
        width: 100%;
    }
    .m-20{
        margin: 0 10px;
    }
    .define{
        width: 100%;
    }
    .condition-box{
        width: 100%;
    }
    .attribute{
        /* width: 28%; */
        margin-right: 8px;
    }
    .addAttrBtn{
        margin-top: 18px;
    }
    .checkbox-box{
        margin-top: 35px;
    }
    .delAttr{
        color: #5087e4;
        cursor: pointer;
        margin-left: 12px;
    }
    .disabled2{
        color: #c3c3c3;
        cursor: not-allowed;
    }
    .define span{
        width: 66px;
        display: inline-block;
        margin-left: 8px;
        margin-right: 16px;
        box-sizing: border-box;
        border: 1px solid #dedede;
    }
    .border-red{
        border-right: 8px solid #f00 !important;
    }
    .border-yellow{
        border-right: 8px solid #ffd200 !important;
    }
    .bool p{
        padding:10px 0 0 10px;
    }
    .details-p{
        text-align: left;
        font-size: 15px;
        margin-bottom: 10px;
    }
    .details-p span{
        font-size: 14px;
        color: #5087e4;
        cursor: pointer;
        margin-left: 20px;
    }
    .date{
        display: inline-block;
        width: 100%;
        background: #eee;
        text-align: left;
        padding: 0 12px;
        box-sizing: border-box;
        margin-top: 12px;
        color: #a4a4a4;
    }
    .text{
        position: absolute;
        right: 0;
        display: inline-block;
        width: 40px;
        text-align: center;
        border: 1px solid #dedede;
        line-height: 32px;
        border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    .m-t-70{
        margin-top: 70px !important;
    }
    .b-128{
        position: absolute;
        bottom: 128px;
        left: 0;
    }
    .enum-title span{
        display: inline-block;
        width: 220px;
    }
    .enum-title>span:last-child{
        margin-left: 30px;
    }
    .add-enum{
        color: #5087e4;
        cursor: pointer;
        width: 100%;
    }
    .enum-box{
        margin-bottom: 10px;
    }
    .m-r-0{
        margin-right: 0 !important;
    }
    .m-r-12{
        margin-right: 12px !important;
    }
    .note{
        height: 133px;
    }
    .m-t-20{
        margin-top: 20px;
    }
    .trigger-box{
        max-height: 138px;
        overflow-y: auto;
        float: left;
        width: 100%;
        padding-bottom: 8px;
        background: #f8f8f8;
        border: 1px solid #dcdcdc;
        padding-left: 10px;
        box-sizing: border-box;
        /* -ms-overflow-style: none;
        overflow: -moz-scrollbars-none; */
    }
    .duration{
        padding-top: 20px;
    }
    .w-415 {
        width: 68% !important;
        margin: 0 8px;
        line-height: 16px;
        border-radius: 5px;
        padding: 8px;
        box-sizing: border-box;
    }
    .border-1{
        border: 1px solid #C0C4CC !important;
    }
    .category-box{
        /* width: 340px; */
        font-size: 15px;
        line-height: 34px;
    }
    .cascader.f-r{
        margin-right: 34px;
    }
    .w-250{
      width: 250px;
    }
</style>
<style>
    #product .enum .el-form-item__label,#product .bool .el-form-item__label,#product .range .el-form-item__label,#product .w-100 .el-form-item__label{
        width: 100%;
        text-align: left;
    }
    #product .range .el-input{
        width: 242px;
    }
    #product .enum .el-input{
        width: 210px;
    }
    #product .bool .el-input{
        width:482px;
        float: right;
    }
    #product .define .el-input__inner{
        border: none !important;
    }
    #product .cascader{
        display: block !important;
        width: 233px !important;
    }
    #product .details .cascader{
        width: 100% !important;
        margin-top: 2px;
    }
    #product .cascader.el-cascader{
        line-height: 34px !important;
    }
    #product .el-cascader-node.in-active-path,.el-cascader-node.is-active{
        font-weight: 500 !important;
    }
    #product .popup .el-input__inner,#product .cascader .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #product .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 11px !important;
    }
    #product .cascader .el-input__inner{
        padding:0 20px 0 10px !important;
    }
    #product .popup .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #product .popup .el-form-item__content{
        line-height: 34px !important;
    }
    #product .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #product .search .el-icon-search{
        line-height: 34px !important;
    }
    #product .el-form-item.m-b-0{
        margin-bottom: 0 !important;
    }
    #product .popup .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #product .func-select .el-select{
        width: 100%;
    }
    #product .func-select .el-input__icon,#product .attribute .el-input__icon{
        line-height: 34px !important;
    }
    #product .cascader .el-input__icon{
        line-height: 34px !important;
    }
    #product .checkbox-box .el-checkbox{
        width: 27% !important;
        /* overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis; */
    }
    #product .checkbox-box .el-checkbox__label{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
    }
    .enum .el-form-item__error{
        padding-top: 0 !important;
    }
    #product .details .el-input__inner{
        border: 0 !important;
        width: 100% !important;
        text-align: center;
    }
    #product .remarks textarea{
        width: 100%;
        height: 76px;
        border: 1px solid #dedede;
        resize: none;
        border-radius: 5px;
        padding:5px;
        box-sizing: border-box;
        line-height: 20px;
    }
    #product .lab-note .el-input__inner{
        text-align: left !important;
    }
    #product .popup .el-form-item.w-28{
        width: 28% !important;
        float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/Product/productList.vue